// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=UTF-8,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23010101%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3e%3cpolyline points=%276 9 12 15 18 9%27%3e%3c/polyline%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scrollbar-gutter: stable;
}

@supports not (scrollbar-gutter: stable) {
  html {
    overflow-y: scroll;
  }
}
body {
  padding: 0;
  margin: 0;
  font-size: 16px;
  line-height: 16px;
  font-weight: 400;
  font-family: "PT Sans", Roboto, Arial, sans-serif;
  overflow-x: hidden;
  background: rgb(6, 198, 222);
  background: linear-gradient(90deg, rgb(6, 198, 222) 0%, rgba(205, 253, 254, 0.8757878151) 0%, rgb(233, 242, 244) 50%);
  color: #010101;
}

h1, h2, h3, h4, h5, h6, p {
  margin: 0;
  padding: 0;
  font-size: 16px;
  line-height: 24px;
}

* {
  box-sizing: border-box;
}

img {
  max-width: 100%;
  height: auto;
}

input, button {
  font-family: "PT Sans", Roboto, Arial, sans-serif;
  border: none;
  background: none;
  outline: none;
  color: #010101;
  font-size: 16px;
}

a {
  color: #010101;
  text-decoration: none;
}

section {
  position: relative;
  z-index: 1;
}

ul, li {
  padding: 0;
  margin: 0;
  list-style: none;
}

.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container {
  max-width: 1220px;
  margin: 0 auto;
  padding: 0 10px;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}

h2 {
  color: #010101;
  font-size: 24px;
  font-weight: 700;
  text-transform: uppercase;
}

.header {
  z-index: 10;
  position: relative;
}
@media (max-width: 1024px) {
  .header {
    position: relative;
  }
}

header {
  padding-top: 20px;
  display: grid;
  grid-template-columns: 1fr max-content 1fr;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #2ccaf1;
  padding-bottom: 15px;
}
@media (max-width: 1024px) {
  header {
    display: flex;
    justify-content: space-between;
    padding: 15px;
  }
}
@media (max-width: 480px) {
  header .logo {
    width: 32px;
  }
}
header .menu {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 24px;
}
@media (max-width: 1024px) {
  header .menu.desktop-menu {
    display: none;
  }
}
@media (max-width: 1024px) {
  header .menu {
    display: none;
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: rgba(255, 255, 255, 0.95);
    -webkit-backdrop-filter: blur(10px);
            backdrop-filter: blur(10px);
    flex-direction: column;
    align-items: center;
    padding: 25px 0;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
    z-index: 50;
  }
  header .menu.active {
    display: flex;
    animation: slideDown 0.3s ease forwards;
  }
  @keyframes slideDown {
    0% {
      transform: translateY(-20px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
}
@media (max-width: 1024px) and (max-width: 480px) {
  header .menu {
    padding: 20px 0;
  }
}
header .menu-item {
  margin-bottom: 15px;
  position: relative;
}
header .menu-item:after {
  content: "";
  position: absolute;
  width: 0;
  height: 2px;
  bottom: -2px;
  left: 0;
  background: #2ccaf1;
  transition: width 0.3s ease;
}
header .menu-item:hover:after {
  width: 100%;
}
header .menu-item a {
  font-size: 20px;
  font-weight: 500;
  transition: all 0.3s ease;
  display: inline-block;
  position: relative;
  padding: 5px 10px;
}
header .menu-item a:hover {
  color: #2ccaf1;
}
header .menu-item a:focus {
  outline: none;
}
header .burger {
  display: none !important;
  cursor: pointer;
  z-index: 100;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.1);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  padding: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.3s ease;
}
@media (max-width: 1024px) {
  header .burger {
    display: flex !important;
  }
}
header .burger:hover {
  background-color: rgba(255, 255, 255, 0.2);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}
header .burger span {
  display: block;
  width: 25px;
  height: 2.5px;
  background: #010101;
  margin: 2.5px 0;
  border-radius: 4px;
  transition: all 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6);
}
header .burger.active span {
  background: #2ccaf1;
}
header .burger.active span:nth-child(1) {
  transform: rotate(45deg) translate(5px, 5px);
}
header .burger.active span:nth-child(2) {
  opacity: 0;
  transform: translateX(-10px);
}
header .burger.active span:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -5px);
}

.socials {
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 10px;
  justify-content: flex-end;
}
@media (max-width: 1024px) {
  .socials {
    display: none;
  }
}
.socials svg {
  fill: #010101;
  width: 35px;
  height: 26px;
  transition: all 0.4s ease;
}
.socials svg.icon-rmiac18 {
  width: 30px;
  height: 34px;
  overflow: visible;
}
.socials-item:hover svg {
  fill: #2ccaf1;
  transform: scale(1.1);
}

.promo-title {
  text-align: center;
  padding: 30px 0;
  font-size: 25px;
  font-weight: 700;
  line-height: 1.35;
}
.promo-box {
  margin-bottom: 10px;
}
.homepage-intro {
  padding: 12px 0 8px;
}
.homepage-intro .promo-title {
  padding-bottom: 12px;
}

.homepage-intro-download {
  display: flex;
  justify-content: center;
  margin: 0 auto 14px;
}
.homepage-intro-download__link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  border-radius: 999px;
  background: rgba(26, 94, 201, 0.08);
  color: #1a5ec9;
  font-size: 15px;
  font-weight: 600;
  text-decoration: none;
  word-break: break-word;
  transition: background 0.15s ease, opacity 0.15s ease;
}
.homepage-intro-download__link:hover {
  background: rgba(26, 94, 201, 0.16);
  opacity: 0.95;
}
.homepage-intro-download__link:focus-visible {
  outline: 2px solid #1a5ec9;
  outline-offset: 2px;
}
.homepage-intro-download__link span {
  word-break: break-word;
}
@media (max-width: 768px) {
  .homepage-intro-download__link {
    font-size: 14px;
    padding: 7px 14px;
  }
}

.promo-highlight {
  display: flex;
  justify-content: center;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 10px 18px;
  max-width: 760px;
  margin: 0 auto 28px;
  padding: 0;
  background: none;
  box-shadow: none;
  text-align: center;
}
.promo-highlight__time {
  font-size: 18px;
  font-weight: 700;
  color: #1a5ec9;
  letter-spacing: 0.02em;
  white-space: nowrap;
}
.promo-highlight__event {
  font-size: 18px;
  line-height: 1.4;
  color: #010101;
}
@media (max-width: 768px) {
  .promo-highlight {
    margin-bottom: 20px;
  }
  .promo-highlight__time, .promo-highlight__event {
    font-size: 16px;
  }
}

.table-section {
  display: flex;
  justify-content: center;
  align-items: center;
}
.table-section .table-container {
  width: 100%;
  max-width: 1200px;
  background: #fff;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  animation: fadeIn 1s ease-in-out;
  margin-bottom: 20px;
}
.table-section .table-container .styled-table {
  width: 100%;
  border-collapse: collapse;
  font-family: "PT Sans", Roboto, Arial, sans-serif;
}
.table-section .table-container .styled-table th, .table-section .table-container .styled-table td {
  padding: 15px 20px;
  text-align: left;
}
@media (max-width: 768px) {
  .table-section .table-container .styled-table th, .table-section .table-container .styled-table td {
    padding: 10px 10px;
    font-size: 15px;
  }
}
.table-section .table-container .styled-table th {
  background: linear-gradient(135deg, #53dde7, #2575fc);
  color: #fff;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1px;
  min-width: 150px;
}
@media (max-width: 768px) {
  .table-section .table-container .styled-table th {
    font-size: 10px;
  }
}
@media (max-width: 600px) {
  .table-section .table-container .styled-table th {
    min-width: auto;
  }
}
@media (max-width: 600px) {
  .table-section .table-container .styled-table th:last-child {
    display: none;
  }
}
.table-section .table-container .styled-table td {
  background: #fff;
  color: #333;
  border-bottom: 1px solid #e0e0e0;
  transition: all 0.3s ease;
}
@media (max-width: 400px) {
  .table-section .table-container .styled-table td {
    font-size: 14px !important;
  }
}
@media (max-width: 600px) {
  .table-section .table-container .styled-table td:last-child {
    display: none;
  }
}
.table-section .table-container .styled-table tr:hover td {
  background: #75d0e0;
  transform: scale(1.02);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}
.table-section .table-container .styled-table tr.is-highlighted td {
  font-size: 18px;
  font-weight: 700;
}
.table-section .table-container .styled-table tr:last-child td {
  border-bottom: none;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.form {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  background-color: rgba(0, 0, 0, 0.5);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  padding: max(12px, env(safe-area-inset-top)) max(12px, env(safe-area-inset-right)) max(12px, env(safe-area-inset-bottom)) max(12px, env(safe-area-inset-left));
}
@media (min-width: 768px) {
  .form {
    padding: 24px 16px;
  }
}

.form-container {
  position: relative;
  width: 100%;
  max-width: 640px;
  margin: auto;
  flex-shrink: 0;
}
.form-container .btn-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 3;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  min-width: 36px;
  min-height: 36px;
  padding: 0;
  margin: 0;
  border: none;
  border-left: 1px solid rgba(1, 1, 1, 0.08);
  border-bottom: 1px solid rgba(1, 1, 1, 0.08);
  border-radius: 0 16px 0 10px;
  background: rgba(255, 255, 255, 0.98);
  color: #010101;
  cursor: pointer;
  flex-shrink: 0;
  transition: background-color 0.2s ease, color 0.2s ease;
}
.form-container .btn-close:hover {
  background: #ffffff;
  color: #2ccaf1;
}
.form-container .btn-close svg {
  width: 18px;
  height: 18px;
  display: block;
}

.form-content,
.form-container .form-title-completed {
  position: relative;
  width: 100%;
  border-radius: 16px;
  background-color: #ffffff;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  border: 1px solid rgba(255, 255, 255, 0.9);
}

.form-content {
  padding: 20px 20px 24px;
}

.form-loading {
  margin: 0 0 16px;
  font-size: 15px;
  color: #6b7280;
}

.form-container .form-title-completed {
  padding: 20px 48px 32px 24px;
  text-align: center;
  font-size: clamp(18px, 4vw, 22px);
  font-weight: 600;
  line-height: 1.4;
  color: #010101;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.3;
  color: #010101;
}

.required-mark {
  margin-left: 2px;
  color: #e53935;
  font-weight: 600;
}

.form-group input,
.form-group select {
  width: 100%;
  min-height: 44px;
  padding: 10px 12px;
  box-sizing: border-box;
  border: 1px solid rgba(44, 202, 241, 0.45);
  border-radius: 10px;
  font-size: 16px;
  line-height: 1.2;
  color: #010101;
  background-color: #ffffff;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #2ccaf1;
  box-shadow: 0 0 0 3px rgba(44, 202, 241, 0.2);
}

.form-group select {
  appearance: none;
  padding-right: 36px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
  cursor: pointer;
}

.form-consents {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 8px 0 20px;
}

.form-checkbox {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0;
}
.form-checkbox input[type=checkbox] {
  width: 18px;
  height: 18px;
  margin-top: 2px;
  flex-shrink: 0;
  cursor: pointer;
}
.form-checkbox .privacy-link {
  display: inline-flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 14px;
  line-height: 1.4;
  color: #2ccaf1;
  text-decoration: underline;
  word-break: break-word;
}
.form-checkbox .privacy-link:hover {
  opacity: 0.85;
}

.error {
  display: block;
  margin-top: 4px;
  font-size: 13px;
  line-height: 1.3;
  color: #e53935;
}

button[type=submit] {
  width: 100%;
  min-height: 48px;
  padding: 12px 16px;
  border: none;
  border-radius: 10px;
  background-color: #2ccaf1;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(44, 202, 241, 0.35);
  transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}
button[type=submit]:hover:not(:disabled) {
  background-color: rgb(15.8293333333, 194.4746666667, 238.5706666667);
  box-shadow: 0 6px 16px rgba(44, 202, 241, 0.4);
}
button[type=submit]:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.popup {
  position: fixed;
  inset: 0;
  z-index: 1100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background-color: rgba(0, 0, 0, 0.55);
  -webkit-backdrop-filter: blur(3px);
          backdrop-filter: blur(3px);
}

.popup-content {
  position: relative;
  width: min(100%, 400px);
  padding: 32px 24px 24px;
  border-radius: 12px;
  background-color: #ffffff;
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);
  text-align: center;
}
.popup-content p {
  margin-top: 12px;
  font-size: 16px;
  line-height: 1.5;
  color: #010101;
}

.close {
  position: absolute;
  top: 8px;
  right: 12px;
  font-size: 28px;
  line-height: 1;
  color: #888;
  cursor: pointer;
}
.close:hover {
  color: #010101;
}

@media (max-width: 768px) {
  .form-content {
    padding: 18px 16px 20px;
    border-radius: 14px;
  }
  .form-container .form-title-completed {
    padding: 18px 44px 28px 20px;
  }
  .form-group {
    margin-bottom: 12px;
  }
}
@media (max-width: 480px) {
  .form {
    padding: max(8px, env(safe-area-inset-top)) max(8px, env(safe-area-inset-right)) max(8px, env(safe-area-inset-bottom)) max(8px, env(safe-area-inset-left));
  }
  .form-content {
    padding: 16px 14px 18px;
    border-radius: 12px;
  }
  .form-container .btn-close {
    border-radius: 0 12px 0 8px;
    width: 34px;
    height: 34px;
    min-width: 34px;
    min-height: 34px;
  }
  .form-container .btn-close svg {
    width: 16px;
    height: 16px;
  }
  .form-group label {
    font-size: 13px;
  }
  .form-checkbox .privacy-link {
    font-size: 13px;
  }
  button[type=submit] {
    min-height: 44px;
  }
}
.App--admin {
  background: #eef1f6;
  min-height: 100vh;
  width: 100%;
  align-items: stretch;
}
.App--admin > * {
  width: 100%;
  min-width: 0;
}

.admin-page, .admin-panel {
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 24px 20px 48px;
  box-sizing: border-box;
  min-width: 0;
  font-family: "PT Sans", Roboto, Arial, sans-serif;
  color: #1f2937;
}
@media (max-width: 768px) {
  .admin-page, .admin-panel {
    padding: 16px 12px 32px;
  }
}

.admin-topbar {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}
.admin-topbar__brand h1 {
  margin: 0 0 4px;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #1f2937;
}
.admin-topbar__brand p {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
}
.admin-topbar__actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.admin-link-btn {
  display: inline-flex;
  align-items: center;
  padding: 9px 16px;
  border-radius: 8px;
  border: 1px solid #e3e8ef;
  background: #ffffff;
  color: #1f2937;
  font-size: 14px;
  font-weight: 500;
  text-decoration: none;
  transition: all 0.15s ease;
}
.admin-link-btn:hover {
  border-color: #2575fc;
  color: #2575fc;
  background: #f5f9ff;
}

.admin-logout-btn {
  padding: 9px 16px;
  border-radius: 8px;
  border: 1px solid #e3e8ef;
  background: #ffffff;
  color: #6b7280;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
}
.admin-logout-btn:hover {
  border-color: #de350b;
  color: #de350b;
  background: #fff5f5;
}

.admin-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 20px;
  width: 100%;
}
@media (max-width: 768px) {
  .admin-stats {
    grid-template-columns: 1fr;
  }
}

.admin-stat-card {
  background: #ffffff;
  border: 1px solid #e3e8ef;
  border-radius: 12px;
  padding: 16px 18px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08), 0 4px 16px rgba(15, 23, 42, 0.04);
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-height: 132px;
}
.admin-stat-card__label {
  font-size: 13px;
  color: #6b7280;
  font-weight: 500;
}
.admin-stat-card__value {
  font-size: 28px;
  font-weight: 700;
  line-height: 1;
  color: #1f2937;
}
.admin-stat-card__summary {
  margin: 0;
  font-size: 12px;
  line-height: 1.4;
  color: #6b7280;
}
.admin-stat-card__hint {
  margin: 0;
  font-size: 12px;
  line-height: 1.4;
  color: #6b7280;
}
.admin-stat-card__breakdown {
  margin: 4px 0 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.admin-stat-card__breakdown li {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  font-size: 12px;
  line-height: 1.35;
}
.admin-stat-card__breakdown-label {
  color: #1f2937;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.admin-stat-card__breakdown-value {
  flex-shrink: 0;
  font-weight: 700;
  color: #1a5ec9;
}
.admin-stat-card--participants .admin-stat-card__value {
  color: #1a5ec9;
}
.admin-stat-card--programs .admin-stat-card__value {
  color: #6a11cb;
}

.admin-status-badge {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 13px;
  font-weight: 600;
}
.admin-status-badge.is-open {
  background: #e3fcef;
  color: #006644;
}
.admin-status-badge.is-closed {
  background: #ffebe6;
  color: #bf2600;
}

.admin-section-card {
  background: #ffffff;
  border: 1px solid #e3e8ef;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08), 0 4px 16px rgba(15, 23, 42, 0.04);
  margin-bottom: 16px;
  overflow: hidden;
  width: 100%;
  min-width: 0;
}
.admin-section-card--highlight {
  border-color: #c8dafc;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
}
.admin-section-card__header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 18px 20px;
  border: none;
  background: transparent;
  text-align: left;
  transition: background 0.15s ease;
}
.admin-section-card__header:hover {
  background: #f8fafc;
}
.admin-section-card__header.is-open {
  border-bottom: 1px solid #e3e8ef;
}
@media (max-width: 768px) {
  .admin-section-card__header {
    flex-wrap: wrap;
  }
  .admin-section-card__header .admin-section-card__toggle {
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(100% - 48px);
  }
  .admin-section-card__header .admin-section-card__actions {
    order: 3;
    width: 100%;
  }
}
.admin-section-card__toggle {
  flex: 1 1;
  min-width: 0;
  display: flex;
  align-items: center;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  color: inherit;
  font: inherit;
}
.admin-section-card__actions {
  flex-shrink: 0;
}
.admin-section-card__programs-toggle {
  padding: 7px 12px;
  font-size: 13px;
}
.admin-section-card__chevron-btn {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
}
.admin-section-card__chevron-btn:hover {
  background: #eef2f7;
}
.admin-section-card__collapse {
  overflow: hidden;
  will-change: height, opacity;
}
.admin-section-card__title-wrap h3 {
  margin: 0 0 2px;
  font-size: 17px;
  font-weight: 600;
  color: #1f2937;
}
.admin-section-card__title-wrap p {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}
.admin-section-card__chevron {
  flex-shrink: 0;
  width: 10px;
  height: 10px;
  border-right: 2px solid #6b7280;
  border-bottom: 2px solid #6b7280;
  transform: rotate(45deg);
  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), margin-top 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}
.admin-section-card__chevron.is-open {
  transform: rotate(-135deg);
  margin-top: 4px;
}
.admin-section-card__body {
  padding: 20px;
  overflow: hidden;
  min-width: 0;
  max-width: 100%;
}
.admin-section-card__body--flat {
  padding: 0;
}

.registration-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  padding: 20px 24px;
  flex-wrap: wrap;
  width: 100%;
  box-sizing: border-box;
}
.registration-controls__info {
  flex: 1 1;
  min-width: 200px;
}
.registration-controls__info h2 {
  margin: 0 0 6px;
  font-size: 16px;
  font-weight: 600;
}
.registration-controls__info p {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.45;
}
.registration-controls button {
  flex-shrink: 0;
}

.admin-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}
.admin-action-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.admin-action-btn--primary {
  background: linear-gradient(135deg, #2575fc, #6a11cb);
  color: #fff;
  box-shadow: 0 2px 8px rgba(37, 117, 252, 0.3);
}
.admin-action-btn--primary:hover:not(:disabled) {
  filter: brightness(1.05);
  transform: translateY(-1px);
}
.admin-action-btn--secondary {
  background: #f3f4f6;
  color: #1f2937;
}
.admin-action-btn--secondary:hover:not(:disabled) {
  background: #e5e7eb;
}
.admin-action-btn--success {
  background: #22a06b;
  color: #fff;
}
.admin-action-btn--success:hover:not(:disabled) {
  filter: brightness(1.05);
}
.admin-action-btn--danger {
  background: #de350b;
  color: #fff;
}
.admin-action-btn--danger:hover:not(:disabled) {
  filter: brightness(1.05);
}
.admin-action-btn--ghost-danger {
  background: transparent;
  border: 1px solid #ffb3a8;
  color: #de350b;
}
.admin-action-btn--ghost-danger:hover:not(:disabled) {
  background: #fff5f5;
}

.complete-registration-btn.clicked,
.reopen-registration-btn.clicked {
  opacity: 0.85;
}

.admin-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}
.admin-toolbar--compact {
  margin-top: 4px;
}
.admin-toolbar__count {
  margin-left: auto;
  font-size: 13px;
  color: #6b7280;
  font-weight: 600;
}

.admin-form {
  background: #f8fafc;
  border: 1px solid #e3e8ef;
  border-radius: 10px;
  padding: 20px;
  min-width: 0;
  max-width: 100%;
  overflow: hidden;
}

.admin-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
  margin-bottom: 20px;
}
@media (max-width: 768px) {
  .admin-form-grid {
    grid-template-columns: 1fr;
  }
}

.admin-field--wide {
  grid-column: 1/-1;
}

.program-title-heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.program-title-heading > label[for=program-title] {
  margin: 0;
}
.program-title-heading__controls {
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
}

.admin-inline-check {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
.admin-inline-check input {
  width: 16px;
  height: 16px;
  margin: 0;
  accent-color: #2575fc;
  cursor: pointer;
}

.program-title-size {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0;
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
}
.program-title-size select {
  width: auto;
  min-width: 150px;
  padding: 6px 10px;
  font-size: 13px;
}

.admin-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}
.admin-field label {
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
}
.admin-field .admin-field-hint {
  font-size: 12px;
  line-height: 1.4;
  color: #6b7280;
}
.admin-field .admin-field-hint code {
  padding: 1px 5px;
  border-radius: 4px;
  background: rgba(31, 41, 55, 0.06);
  font-size: 12px;
}
.admin-field input,
.admin-field textarea,
.admin-field select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e3e8ef;
  border-radius: 8px;
  font-size: 15px;
  font-family: inherit;
  color: #1f2937;
  background: #ffffff;
  box-sizing: border-box;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.admin-field input::placeholder,
.admin-field textarea::placeholder,
.admin-field select::placeholder {
  color: #9ca3af;
}
.admin-field input:focus,
.admin-field textarea:focus,
.admin-field select:focus {
  outline: none;
  border-color: #2575fc;
  box-shadow: 0 0 0 3px rgba(37, 117, 252, 0.12);
}
.admin-field input:disabled,
.admin-field textarea:disabled,
.admin-field select:disabled {
  background: #f3f4f6;
  color: #6b7280;
}
.admin-field textarea {
  resize: vertical;
  min-height: 72px;
}

.admin-form-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
  padding-top: 16px;
  border-top: 1px solid #e3e8ef;
  flex-wrap: wrap;
}
@media (max-width: 768px) {
  .admin-form-footer {
    flex-direction: column;
  }
  .admin-form-footer .admin-action-btn {
    width: 100%;
  }
}

.table-row {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  padding: 14px;
  background: #ffffff;
  border: 1px solid #e3e8ef;
  border-radius: 10px;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  min-width: 0;
  max-width: 100%;
}
.table-row:hover {
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);
}
.table-row.is-selected {
  border-color: #2575fc;
  background: #f5f9ff;
}
@media (max-width: 768px) {
  .table-row {
    flex-direction: column;
  }
}
.table-row__number {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 700;
  color: #6b7280;
  margin-top: 24px;
}
@media (max-width: 768px) {
  .table-row__number {
    margin-top: 0;
  }
}
.table-row__fields {
  flex: 1 1;
  min-width: 0;
  display: grid;
  grid-template-columns: minmax(100px, 140px) minmax(0, 1fr) minmax(0, 1fr);
  gap: 12px;
}
@media (max-width: 1024px) {
  .table-row__fields {
    grid-template-columns: 1fr;
  }
}

.row-actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex-shrink: 0;
  min-width: 110px;
}
@media (max-width: 768px) {
  .row-actions {
    flex-direction: row;
    flex-wrap: wrap;
    min-width: 0;
  }
}

.row-action-btn {
  padding: 7px 10px;
  border: none;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: filter 0.15s ease;
}
.row-action-btn--warn {
  background: #fff7e6;
  color: #b76e00;
}
.row-action-btn--danger {
  background: #ffebe6;
  color: #de350b;
}
.row-action-btn--select {
  background: #e6f4ff;
  color: #0958d9;
}
.row-action-btn--select.is-active {
  background: #2575fc;
  color: #fff;
}
.row-action-btn:hover {
  filter: brightness(0.96);
}

.registrations-list-wrap {
  margin-top: 4px;
}

.registration-forum-tabs-scroll {
  overflow-x: auto;
  margin: 0 0 16px;
  padding-bottom: 4px;
  max-width: 100%;
  -webkit-overflow-scrolling: touch;
}

.registration-forum-tabs {
  display: flex;
  gap: 8px;
  width: max-content;
  max-width: none;
}

.registration-forum-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border: 1px solid #e3e8ef;
  border-radius: 999px;
  background: #fff;
  color: #1f2937;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  white-space: nowrap;
}
.registration-forum-tab__label {
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.registration-forum-tab__count {
  min-width: 22px;
  padding: 2px 7px;
  border-radius: 999px;
  background: #eef2f7;
  color: #6b7280;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
}
.registration-forum-tab.is-active {
  border-color: #2575fc;
  background: #e8f1ff;
  color: #1a5ec9;
}
.registration-forum-tab.is-active .registration-forum-tab__count {
  background: #2575fc;
  color: #fff;
}

.registration-forum-panel {
  min-width: 0;
}

.registrations-list {
  overflow-x: auto;
  border: 1px solid #e3e8ef;
  border-radius: 10px;
}

.registrations-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.registrations-table th,
.registrations-table td {
  padding: 11px 14px;
  text-align: left;
  border-bottom: 1px solid #e3e8ef;
  white-space: nowrap;
}
.registrations-table th {
  background: #f8fafc;
  color: #6b7280;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  position: sticky;
  top: 0;
}
.registrations-table tbody tr:hover td {
  background: #f8fafc;
}
.registrations-table tbody tr:last-child td {
  border-bottom: none;
}

.admin-empty-state {
  text-align: center;
  padding: 32px 20px;
  color: #6b7280;
}
.admin-empty-state p {
  margin: 0 0 12px;
  font-size: 15px;
}
.admin-empty-state--compact {
  padding: 24px 16px;
  background: #f8fafc;
  border: 1px dashed #e3e8ef;
  border-radius: 10px;
  margin-bottom: 12px;
}

.program-documents-editor {
  min-width: 0;
  max-width: 100%;
}
.program-documents-editor .program-tabs-scroll {
  overflow-x: auto;
  margin-bottom: 16px;
  padding-bottom: 4px;
  max-width: 100%;
  -webkit-overflow-scrolling: touch;
}
.program-documents-editor .program-tabs {
  display: flex;
  gap: 8px;
  width: max-content;
  max-width: none;
}
.program-documents-editor .program-tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  border: 1px solid #e3e8ef;
  border-radius: 8px;
  background: #ffffff;
  color: #1f2937;
  font-size: 13px;
  font-weight: 500;
  cursor: grab;
  transition: all 0.15s ease;
  max-width: 240px;
}
.program-documents-editor .program-tab__index {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f3f4f6;
  border-radius: 4px;
  font-size: 11px;
  font-weight: 700;
  color: #6b7280;
}
.program-documents-editor .program-tab__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.program-documents-editor .program-tab__drag {
  color: #c4c9d2;
  font-size: 11px;
  letter-spacing: -2px;
}
.program-documents-editor .program-tab.is-active {
  border-color: #2575fc;
  background: #f0f7ff;
  color: #2575fc;
}
.program-documents-editor .program-tab.is-active .program-tab__index {
  background: #2575fc;
  color: #fff;
}
.program-documents-editor .program-tab.is-drag-over {
  border-color: #6a11cb;
  background: #f8f4ff;
}
.program-documents-editor .program-tab--add {
  cursor: pointer;
  border-style: dashed;
  color: #6b7280;
  max-width: none;
}
.program-documents-editor .program-tab--add:hover {
  border-color: #2575fc;
  color: #2575fc;
}
.program-documents-editor .program-tab:active {
  cursor: grabbing;
}
.program-documents-editor .program-editor-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
}
.program-documents-editor .program-editor-hint {
  margin: 0;
  font-size: 13px;
  color: #6b7280;
}
.program-documents-editor .program-table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}
.program-documents-editor .program-table-header h4 {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
}
.program-documents-editor .program-table-count {
  font-size: 12px;
  color: #6b7280;
  background: #f3f4f6;
  padding: 3px 8px;
  border-radius: 999px;
}

.program-block + .program-block {
  margin-top: 8px;
}

.admin-modal-overlay, .popup-overlay {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.admin-modal, .popup-content {
  background: #ffffff;
  border-radius: 16px;
  padding: 28px 32px;
  max-width: 360px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.2);
}
.admin-modal h3, .popup-content h3 {
  margin: 12px 0 8px;
  font-size: 18px;
  font-weight: 700;
}
.admin-modal p, .popup-content p {
  margin: 0;
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
}
.admin-modal--confirm {
  max-width: 420px;
  text-align: left;
}
.admin-modal--confirm h3,
.admin-modal--confirm p {
  text-align: left;
}
.admin-modal--confirm .admin-modal__icon {
  margin: 0 0 4px;
}
.admin-modal__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 20px;
  justify-content: flex-end;
}
.admin-modal__icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  font-size: 22px;
  font-weight: 700;
}
.admin-modal__icon--success {
  background: #e3fcef;
  color: #22a06b;
}
.admin-modal__icon--warning {
  background: #fff7e6;
  color: #ff991f;
}

.admin-toast {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 12px 18px;
  border-radius: 10px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);
  z-index: 9999;
  max-width: calc(100vw - 40px);
}
.admin-toast--success {
  background: #22a06b;
}

.admin-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  padding: 40px 20px;
}
.admin-loading .loading-spinner {
  width: 44px;
  height: 44px;
  border: 3px solid #e5e7eb;
  border-top-color: #2575fc;
  border-radius: 50%;
  margin-bottom: 16px;
  animation: admin-spin 0.8s linear infinite;
}
.admin-loading p {
  margin: 0;
  font-size: 15px;
  color: #6b7280;
}

@keyframes admin-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .admin-topbar__brand h1 {
    font-size: 22px;
  }
  .registration-controls {
    flex-direction: column;
    align-items: stretch;
  }
  .registration-controls button {
    width: 100%;
  }
  .admin-toolbar {
    flex-direction: column;
  }
  .admin-toolbar .admin-action-btn {
    width: 100%;
  }
}
.form-field-row.is-drag-over {
  border-color: #2575fc;
  box-shadow: 0 0 0 3px rgba(37, 117, 252, 0.12);
}
.form-field-row.is-locked {
  background: #f8fafc;
}
.form-field-row__handle {
  cursor: grab;
  -webkit-user-select: none;
          user-select: none;
  letter-spacing: -2px;
}
.form-field-row__handle:active {
  cursor: grabbing;
}
.form-field-row__fields {
  grid-template-columns: minmax(0, 1.4fr) minmax(120px, 160px) minmax(0, 1fr);
  align-items: start;
}
@media (max-width: 1024px) {
  .form-field-row__fields {
    grid-template-columns: 1fr;
  }
}

.form-field-required {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 22px;
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  cursor: pointer;
}
.form-field-required input {
  width: 16px;
  height: 16px;
  accent-color: #2575fc;
}
@media (max-width: 1024px) {
  .form-field-required {
    margin-top: 0;
  }
}

.form-field-locked-note {
  grid-column: 1/-1;
  margin: 0;
  font-size: 12px;
  color: #6b7280;
}

.form-field-options {
  grid-column: 1/-1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  background: #f8fafc;
  border: 1px dashed #e3e8ef;
  border-radius: 8px;
}
.form-field-options__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #6b7280;
}

.form-field-option {
  display: flex;
  gap: 8px;
  align-items: center;
}
.form-field-option input {
  flex: 1 1;
  min-width: 0;
  padding: 8px 10px;
  border: 1px solid #e3e8ef;
  border-radius: 8px;
  font-size: 14px;
  font-family: inherit;
  box-sizing: border-box;
}
.form-field-option input:focus {
  outline: none;
  border-color: #2575fc;
}

.registration-form-editor .admin-form-footer {
  justify-content: flex-start;
}
.registration-form-editor .row-action-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.homepage-intro-editor .program-editor-hint {
  margin-bottom: 16px;
}

.homepage-intro-preview {
  margin-top: 4px;
  padding: 16px;
  border: 1px dashed #e3e8ef;
  border-radius: 12px;
  background: linear-gradient(90deg, rgba(205, 253, 254, 0.7) 0%, rgb(233, 242, 244) 50%);
}
.homepage-intro-preview__label {
  display: block;
  margin-bottom: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.homepage-intro-preview__empty {
  margin: 12px 0 4px;
  text-align: center;
  color: #6b7280;
  font-size: 14px;
}
.homepage-intro-preview .homepage-intro {
  padding: 0;
}
.homepage-intro-preview .promo-title {
  padding: 16px 8px 10px;
}
.homepage-intro-preview .promo-highlight {
  margin-bottom: 8px;
}

.admin-login {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 24px 16px;
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);
}
.admin-login .admin-login-form {
  width: 100%;
  min-width: 280px;
  max-width: 400px;
  background: #fff;
  padding: 32px 28px;
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
}
.admin-login .admin-login-form h3 {
  margin: 0 0 24px;
  color: #333;
  font-size: 20px;
  font-weight: 600;
  line-height: 1.3;
}
.admin-login .admin-login-form input {
  width: 100%;
  padding: 12px 14px;
  margin-bottom: 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 16px;
  box-sizing: border-box;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.admin-login .admin-login-form input:focus {
  border-color: #2575fc;
  outline: none;
  box-shadow: 0 0 0 2px rgba(37, 117, 252, 0.2);
}
.admin-login .admin-login-form input:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.admin-login .admin-login-form .error {
  color: #dc3545;
  margin: 0 0 12px;
  font-size: 14px;
}
.admin-login .admin-login-form button {
  width: 100%;
  background: linear-gradient(135deg, #2575fc, #6a11cb);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.2s ease;
}
.admin-login .admin-login-form button:hover:not(:disabled) {
  background: linear-gradient(135deg, #1a5ec9, #5910a8);
  transform: translateY(-1px);
}
.admin-login .admin-login-form button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.admin-login .admin-login-form .admin-login-home-link {
  display: inline-block;
  margin-top: 16px;
  color: #666;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.2s ease;
}
.admin-login .admin-login-form .admin-login-home-link:hover {
  color: #2575fc;
  text-decoration: underline;
}

.footer {
  margin-top: auto;
  padding: 48px 0 20px;
  position: relative;
  z-index: 1;
  background: linear-gradient(135deg, #eefbfe 0%, #e7f4f6 100%);
  border-top: 1px solid rgba(44, 202, 241, 0.28);
}
@media (max-width: 768px) {
  .footer {
    padding-top: 36px;
  }
}
.footer-wrapper {
  display: grid;
  grid-template-columns: minmax(210px, 1.15fr) repeat(3, minmax(180px, 1fr));
  gap: 40px;
  align-items: start;
}
@media (max-width: 1024px) {
  .footer-wrapper {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 36px 48px;
  }
}
@media (max-width: 768px) {
  .footer-wrapper {
    grid-template-columns: 1fr;
    gap: 30px;
  }
}
.footer-brand {
  max-width: 270px;
}
@media (max-width: 768px) {
  .footer-brand {
    max-width: none;
  }
}
.footer-logo {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 18px;
}
.footer-logo img {
  width: 86px;
  height: auto;
}
.footer-description {
  color: #71848a;
  font-size: 14px;
  line-height: 1.25;
}
.footer-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  color: #010101;
}
.footer-section h3 {
  margin: 0 0 8px;
  font-size: 20px;
  line-height: 1.2;
  font-weight: 700;
}
.footer-section p,
.footer-section address,
.footer-section a {
  margin: 0;
  color: inherit;
  font-size: 15px;
  line-height: 1.35;
  font-style: normal;
}
.footer-section a {
  transition: color 0.2s ease;
}
.footer-section a:hover {
  color: #2ccaf1;
}
.footer-section .socials {
  display: flex;
  justify-content: flex-start;
  margin-top: 10px;
}
.footer-schedule {
  gap: 14px;
}
.footer-schedule h3 {
  margin-bottom: 2px;
}
.footer-bottom {
  margin-top: 38px;
  padding-top: 18px;
  border-top: 1px solid rgba(1, 1, 1, 0.1);
  color: #71848a;
  font-size: 13px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/styles/reset.scss","webpack://./src/styles/main.scss","webpack://./src/styles/variables.scss","webpack://./src/styles/header.scss","webpack://./src/styles/mixins.scss","webpack://./src/styles/banner.scss","webpack://./src/styles/table.scss","webpack://./src/styles/registration.scss","webpack://./src/styles/adminPanel.scss","webpack://./src/styles/adminLogin.scss","webpack://./src/styles/footer.scss"],"names":[],"mappings":"AAEA;EACI,wBAAA;ACAJ;;ADGA;EACI;IACI,kBAAA;ECAN;AACF;ADGA;EACI,UAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,iDEbe;EFcf,kBAAA;EAEA,4BAAA;EACA,qHAAA;EACA,cEvBM;ADqBV;;ADKA;EACI,SAAA;EACA,UAAA;EACA,eAAA;EACA,iBAAA;ACFJ;;ADKA;EACI,sBAAA;ACFJ;;ADKA;EACI,eAAA;EACA,YAAA;ACFJ;;ADKA;EACI,iDEtCe;EFuCf,YAAA;EACA,gBAAA;EACA,aAAA;EACA,cE/CM;EFgDN,eAAA;ACFJ;;ADKA;EACI,cEpDM;EFqDN,qBAAA;ACFJ;;ADKA;EACI,kBAAA;EACA,UAAA;ACFJ;;ADKA;EACI,UAAA;EACA,SAAA;EACA,gBAAA;ACFJ;;ADKA;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;ACFJ;;ADKA;EACI,iBAAA;EACA,cAAA;EACA,eAAA;ACFJ;;ADMA;;EAEI,wBAAA;EACA,SAAA;ACHJ;;ADMA;EACI,0BAAA;ACHJ;;ADMA;EACI,cE3FM;EF4FN,eAAA;EACA,gBAAA;EACA,yBAAA;ACHJ;;AE3FA;EACE,WAAA;EACA,kBAAA;AF8FF;AE5FE;EAJF;IAKI,kBAAA;EF+FF;AACF;;AE5FA;EACE,iBAAA;EACA,aAAA;EACA,0CAAA;EACA,8BAAA;EACA,mBAAA;EACA,gCAAA;EACA,oBAAA;AF+FF;AE7FE;EATF;IAUI,aAAA;IACA,8BAAA;IACA,aAAA;EFgGF;AACF;AE7FI;EADF;IAEI,WAAA;EFgGJ;AACF;AE7FE;EC7BE,aAAA;EACA,mBAAA;EACA,uBAAA;ED6BA,gBAAA;AFiGJ;AE9FM;EADF;IAEI,aAAA;EFiGN;AACF;AE9FI;EAVF;IAWI,aAAA;IACA,kBAAA;IACA,SAAA;IACA,OAAA;IACA,WAAA;IACA,qCAAA;IACA,mCAAA;YAAA,2BAAA;IACA,sBAAA;IACA,mBAAA;IACA,eAAA;IACA,0CAAA;IACA,+BAAA;IACA,gCAAA;IACA,WAAA;EFiGJ;EE/FI;IACE,aAAA;IACA,uCAAA;EFiGN;EE9FI;IACE;MACE,4BAAA;MACA,UAAA;IFgGN;IE9FI;MACE,wBAAA;MACA,UAAA;IFgGN;EACF;AACF;AE9FM;EA1CJ;IA2CM,eAAA;EFiGN;AACF;AE9FI;EACE,mBAAA;EACA,kBAAA;AFgGN;AE9FM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,mBDtFC;ECuFD,2BAAA;AFgGR;AE7FM;EACE,WAAA;AF+FR;AE5FM;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iBAAA;AF8FR;AE5FQ;EACE,cDvGD;ADqMT;AE3FQ;EACE,aAAA;AF6FV;AEvFE;EACE,wBAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,0CAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBAAA;AFyFJ;AEvFI;EAhBF;IAiBI,wBAAA;EF0FJ;AACF;AExFI;EACE,0CAAA;EACA,yCAAA;AF0FN;AEvFI;EACE,cAAA;EACA,WAAA;EACA,aAAA;EACA,mBDhJI;ECiJJ,eAAA;EACA,kBAAA;EACA,wDAAA;AFyFN;AErFM;EACE,mBDtJC;AD6OT;AEpFM;EACE,4CAAA;AFsFR;AEnFM;EACE,UAAA;EACA,4BAAA;AFqFR;AElFM;EACE,8CAAA;AFoFR;;AE9EA;EC1KI,aAAA;EACA,mBAAA;EACA,uBAAA;ED0KF,gBAAA;EACA,yBAAA;AFmFF;AEjFE;EALF;IAMI,aAAA;EFoFF;AACF;AElFE;EACE,aDrLM;ECsLN,WAAA;EACA,YAAA;EACA,yBAAA;AFoFJ;AEjFE;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AFmFJ;AE9EM;EACE,aDlMC;ECmMD,qBAAA;AFgFR;;AIpRI;EACI,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AJuRR;AIrRI;EACI,mBAAA;AJuRR;AI5QA;EACI,mBAAA;AJ8QJ;AI5QI;EACI,oBAAA;AJ8QR;;AI1QA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AJ6QJ;AI3QI;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,oBAAA;EACA,mCAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,qDAAA;AJ6QR;AI3QQ;EACI,mCAAA;EACA,aAAA;AJ6QZ;AI1QQ;EACI,0BAAA;EACA,mBAAA;AJ4QZ;AIzQQ;EACI,sBAAA;AJ2QZ;AIxQQ;EA5BJ;IA6BQ,eAAA;IACA,iBAAA;EJ2QV;AACF;;AIvQA;EACI,aAAA;EACA,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AJ0QJ;AIxQI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;AJ0QR;AIvQI;EACI,eAAA;EACA,gBAAA;EACA,cH5FE;ADqWV;AItQI;EA3BJ;IA4BQ,mBAAA;EJyQN;EIvQM;IAEI,eAAA;EJwQV;AACF;;AK7UA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;ALgVF;AK9UE;EACE,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;ALgVJ;AK9UI;EACE,WAAA;EACA,yBAAA;EACA,iDJ7Ca;AD6XnB;AK9UM;EACE,kBAAA;EACA,gBAAA;ALgVR;AK9UQ;EAJF;IAKI,kBAAA;IACA,eAAA;ELiVR;AACF;AK9UM;EACE,qDAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;ALgVR;AK/UQ;EARF;IASI,eAAA;ELkVR;AACF;AKjVQ;EAXF;IAYI,eAAA;ELoVR;AACF;AKjVQ;EADF;IAEI,aAAA;ELoVR;AACF;AKhVM;EACE,gBAAA;EACA,WAAA;EACA,gCAAA;EACA,yBAAA;ALkVR;AKhVQ;EANF;IAOI,0BAAA;ELmVR;AACF;AK/UQ;EADF;IAEI,aAAA;ELkVR;AACF;AK9UM;EACE,mBAAA;EACA,sBAAA;EACA,yCAAA;ALgVR;AK7UM;EACE,eAAA;EACA,gBAAA;AL+UR;AK5UM;EACE,mBAAA;AL8UR;;AKvUA;EACE;IACE,UAAA;IACA,2BAAA;EL0UF;EKxUA;IACE,UAAA;IACA,wBAAA;EL0UF;AACF;AM3cA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,4BAAA;EACA,iCAAA;EACA,oCAAA;EACA,kCAAA;UAAA,0BAAA;EACA,8JACE;AN4cJ;AMvcE;EAlBF;IAmBI,kBAAA;EN0cF;AACF;;AMvcA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,cAAA;AN0cF;AMxcE;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,SAAA;EACA,YAAA;EACA,0CAAA;EACA,4CAAA;EACA,4BAAA;EACA,qCAAA;EACA,cLjDM;EKkDN,eAAA;EACA,cAAA;EACA,uDAAA;AN0cJ;AMxcI;EACE,mBLtDE;EKuDF,cLtDG;ADggBT;AMvcI;EACE,WAAA;EACA,YAAA;EACA,cAAA;ANycN;;AMpcA;;EAEE,kBAAA;EACA,WAAA;EACA,mBAAA;EACA,yBLvEM;EKwEN,2CAAA;EACA,0CAAA;ANucF;;AMpcA;EACE,uBAAA;ANucF;;AMpcA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;ANucF;;AMpcA;EACE,4BAAA;EACA,kBAAA;EACA,iCAAA;EACA,gBAAA;EACA,gBAAA;EACA,cL7FQ;ADoiBV;;AMpcA;EACE,mBAAA;ANucF;;AMpcA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,cL1GQ;ADijBV;;AMpcA;EACE,gBAAA;EACA,cAAA;EACA,gBAAA;ANucF;;AMpcA;;EAEE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0CAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,cL7HQ;EK8HR,yBL7HM;EK8HN,wDAAA;ANucF;AMrcE;;EACE,aAAA;EACA,qBLjIK;EKkIL,6CAAA;ANwcJ;;AMpcA;EACE,gBAAA;EACA,mBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sCAAA;EACA,qBAAA;EACA,eAAA;ANucF;;AMpcA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;ANucF;;AMpcA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;EACA,SAAA;ANucF;AMrcE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;ANucJ;AMpcE;EACE,oBAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cL3KK;EK4KL,0BAAA;EACA,sBAAA;ANscJ;AMpcI;EACE,aAAA;ANscN;;AMjcA;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;ANocF;;AMjcA;EACE,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,yBLnMO;EKoMP,cLrMM;EKsMN,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,+CAAA;EACA,iFAAA;ANocF;AMlcE;EACE,oEAAA;EACA,8CAAA;ANocJ;AMjcE;EACE,YAAA;EACA,mBAAA;ANmcJ;;AM/bA;EACE,eAAA;EACA,QAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,qCAAA;EACA,kCAAA;UAAA,0BAAA;ANkcF;;AM/bA;EACE,kBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBLzOM;EK0ON,0CAAA;EACA,kBAAA;ANkcF;AMhcE;EACE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cLlPM;ADorBV;;AM9bA;EACE,kBAAA;EACA,QAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;ANicF;AM/bE;EACE,cLhQM;ADisBV;;AM7bA;EACE;IACE,uBAAA;IACA,mBAAA;ENgcF;EM7bA;IACE,4BAAA;EN+bF;EM5bA;IACE,mBAAA;EN8bF;AACF;AM3bA;EACE;IACE,0JACE;EN4bJ;EMtbA;IACE,uBAAA;IACA,mBAAA;ENwbF;EMrbA;IACE,2BAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;ENubF;EMrbE;IACE,WAAA;IACA,YAAA;ENubJ;EMnbA;IACE,eAAA;ENqbF;EMlbA;IACE,eAAA;ENobF;EMjbA;IACE,gBAAA;ENmbF;AACF;AO5tBA;EACE,mBATS;EAUT,iBAAA;EACA,WAAA;EACA,oBAAA;AP8tBF;AO5tBE;EACE,WAAA;EACA,YAAA;AP8tBJ;;AO1tBA;EACE,WAAA;EACA,iBAAA;EACA,cAAA;EACA,uBAAA;EACA,sBAAA;EACA,YAAA;EACA,iDN7BiB;EM8BjB,cAzBW;APsvBb;AO3tBE;EAVF;IAWI,uBAAA;EP8tBF;AACF;;AO1tBA;EACE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AP6tBF;AO1tBI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,cA/CO;AP2wBb;AOztBI;EACE,SAAA;EACA,eAAA;EACA,cApDa;AP+wBnB;AOvtBE;EACE,aAAA;EACA,SAAA;EACA,eAAA;APytBJ;;AOrtBA;EACE,oBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAxEc;EAyEd,cAvEW;EAwEX,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,0BAAA;APwtBF;AOttBE;EACE,qBAvFY;EAwFZ,cAxFY;EAyFZ,mBAAA;APwtBJ;;AOptBA;EACE,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBA1Fc;EA2Fd,cAxFiB;EAyFjB,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;APutBF;AOrtBE;EACE,qBArGW;EAsGX,cAtGW;EAuGX,mBAAA;APutBJ;;AOltBA;EACE,aAAA;EACA,gDAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;APqtBF;AOntBE;EAPF;IAQI,0BAAA;EPstBF;AACF;;AOntBA;EACE,mBAtHc;EAuHd,yBAAA;EACA,mBApHa;EAqHb,kBAAA;EACA,+EArHa;EAsHb,aAAA;EACA,sBAAA;EACA,QAAA;EACA,iBAAA;APstBF;AOptBE;EACE,eAAA;EACA,cA/He;EAgIf,gBAAA;APstBJ;AOntBE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAxIS;AP61Bb;AOltBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cA9Ie;APk2BnB;AOjtBE;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cArJe;APw2BnB;AOhtBE;EACE,eAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;APktBJ;AOhtBI;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;EACA,iBAAA;APktBN;AO9sBE;EACE,cA5KS;EA6KT,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;APgtBJ;AO7sBE;EACE,cAAA;EACA,gBAAA;EACA,cA9LiB;AP64BrB;AO3sBI;EACE,cAnMe;APg5BrB;AOxsBI;EACE,cAxMS;APk5Bf;;AOrsBA;EACE,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;APwsBF;AOtsBE;EACE,mBAAA;EACA,cAAA;APwsBJ;AOrsBE;EACE,mBAAA;EACA,cAAA;APusBJ;;AOlsBA;EACE,mBA9Nc;EA+Nd,yBAAA;EACA,mBA5Na;EA6Nb,+EA5Na;EA6Nb,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;APqsBF;AOnsBE;EACE,qBAAA;EACA,6DAAA;APqsBJ;AOlsBE;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,gBAAA;EACA,iCAAA;APosBJ;AOlsBI;EACE,mBAAA;APosBN;AOjsBI;EACE,gCAAA;APmsBN;AOhsBI;EApBF;IAqBI,eAAA;EPmsBJ;EOjsBI;IACE,YAAA;IAAA,cAAA;IAAA,6BAAA;EPmsBN;EOhsBI;IACE,QAAA;IACA,WAAA;EPksBN;AACF;AO9rBE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,aAAA;APgsBJ;AO7rBE;EACE,cAAA;AP+rBJ;AO5rBE;EACE,iBAAA;EACA,eAAA;AP8rBJ;AO3rBE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;AP6rBJ;AO3rBI;EACE,mBAAA;AP6rBN;AOzrBE;EACE,gBAAA;EACA,4BAAA;AP2rBJ;AOvrBI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,cA/TO;APw/Bb;AOtrBI;EACE,SAAA;EACA,eAAA;EACA,cApUa;AP4/BnB;AOprBE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,+BAAA;EACA,gCAAA;EACA,wBAAA;EACA,uGAAA;APsrBJ;AOprBI;EACE,0BAAA;EACA,eAAA;APsrBN;AOlrBE;EACE,aAAA;EACA,gBAAA;EACA,YAAA;EACA,eAAA;APorBJ;AOlrBI;EACE,UAAA;APorBN;;AO9qBA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,sBAAA;APirBF;AO/qBE;EACE,SAAA;EACA,gBAAA;APirBJ;AO/qBI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;APirBN;AO9qBI;EACE,SAAA;EACA,eAAA;EACA,cA3Xa;EA4Xb,iBAAA;APgrBN;AO5qBE;EACE,cAAA;AP8qBJ;;AOzqBA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;AP4qBF;AO1qBE;EACE,YAAA;EACA,mBAAA;AP4qBJ;AOzqBE;EACE,qDAAA;EACA,WAAA;EACA,6CAAA;AP2qBJ;AOzqBI;EACE,wBAAA;EACA,2BAAA;AP2qBN;AOvqBE;EACE,mBAAA;EACA,cAvaS;APglCb;AOvqBI;EACE,mBAAA;APyqBN;AOrqBE;EACE,mBArbY;EAsbZ,WAAA;APuqBJ;AOrqBI;EACE,wBAAA;APuqBN;AOnqBE;EACE,mBA7bW;EA8bX,WAAA;APqqBJ;AOnqBI;EACE,wBAAA;APqqBN;AOjqBE;EACE,uBAAA;EACA,yBAAA;EACA,cAxcW;AP2mCf;AOjqBI;EACE,mBAAA;APmqBN;;AO9pBA;;EAEE,aAAA;APiqBF;;AO9pBA;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;APiqBF;AO/pBE;EACE,eAAA;APiqBJ;AO9pBE;EACE,iBAAA;EACA,eAAA;EACA,cA7de;EA8df,gBAAA;APgqBJ;;AO3pBA;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AP8pBF;;AO3pBA;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;AP8pBF;AO5pBE;EANF;IAOI,0BAAA;EP+pBF;AACF;;AO5pBA;EACE,iBAAA;AP+pBF;;AO5pBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,eAAA;AP+pBF;AO7pBE;EACE,SAAA;AP+pBJ;AO5pBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AP8pBJ;;AO1pBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAvhBW;EAwhBX,eAAA;EACA,yBAAA;UAAA,iBAAA;AP6pBF;AO3pBE;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,qBAxiBY;EAyiBZ,eAAA;AP6pBJ;;AOzpBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cA1iBiB;APssCnB;AO1pBE;EACE,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AP4pBJ;;AOxpBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AP2pBF;AOzpBE;EACE,eAAA;EACA,gBAAA;EACA,cA5jBe;APutCnB;AOxpBE;EACE,eAAA;EACA,gBAAA;EACA,cAlkBe;AP4tCnB;AOxpBI;EACE,gBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;AP0pBN;AOtpBE;;;EAGE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,cAtlBS;EAulBT,mBAzlBY;EA0lBZ,sBAAA;EACA,0DAAA;APwpBJ;AOtpBI;;;EACE,cAAA;AP0pBN;AOvpBI;;;EACE,aAAA;EACA,qBA1mBU;EA2mBV,8CAAA;AP2pBN;AOxpBI;;;EACE,mBAAA;EACA,cAtmBa;APkwCnB;AOxpBE;EACE,gBAAA;EACA,gBAAA;AP0pBJ;;AOtpBA;EACE,aAAA;EACA,yBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,6BAAA;EACA,eAAA;APypBF;AOvpBE;EATF;IAUI,sBAAA;EP0pBF;EOxpBE;IACE,WAAA;EP0pBJ;AACF;;AOrpBA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;EACA,aAAA;EACA,mBA3oBc;EA4oBd,yBAAA;EACA,mBAAA;EACA,0DAAA;EACA,YAAA;EACA,eAAA;APwpBF;AOtpBE;EACE,4CAAA;APwpBJ;AOrpBE;EACE,qBA9pBY;EA+pBZ,mBAAA;APupBJ;AOppBE;EArBF;IAsBI,sBAAA;EPupBF;AACF;AOrpBE;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAvqBe;EAwqBf,gBAAA;APupBJ;AOrpBI;EAdF;IAeI,aAAA;EPwpBJ;AACF;AOrpBE;EACE,SAAA;EACA,YAAA;EACA,aAAA;EACA,yEAAA;EACA,SAAA;APupBJ;AOrpBI;EAPF;IAQI,0BAAA;EPwpBJ;AACF;;AOppBA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,cAAA;EACA,gBAAA;APupBF;AOrpBE;EAPF;IAQI,mBAAA;IACA,eAAA;IACA,YAAA;EPwpBF;AACF;;AOrpBA;EACE,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;APwpBF;AOtpBE;EACE,mBAAA;EACA,cAAA;APwpBJ;AOrpBE;EACE,mBAAA;EACA,cAhuBW;APu3Cf;AOppBE;EACE,mBAAA;EACA,cAAA;APspBJ;AOppBI;EACE,mBA5uBU;EA6uBV,WAAA;APspBN;AOlpBE;EACE,wBAAA;APopBJ;;AO/oBA;EACE,eAAA;APkpBF;;AO/oBA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,iCAAA;APkpBF;;AO/oBA;EACE,aAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;APkpBF;;AO/oBA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,cAzwBW;EA0wBX,eAAA;EACA,gBAAA;EACA,eAAA;EACA,4EAAA;EACA,mBAAA;APkpBF;AOhpBE;EACE,gBAAA;EACA,gBAAA;EACA,uBAAA;APkpBJ;AO/oBE;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cA1xBe;EA2xBf,eAAA;EACA,gBAAA;EACA,kBAAA;APipBJ;AO9oBE;EACE,qBA3yBY;EA4yBZ,mBAAA;EACA,cA5yBiB;AP47CrB;AO9oBI;EACE,mBAhzBU;EAizBV,WAAA;APgpBN;;AO3oBA;EACE,YAAA;AP8oBF;;AO3oBA;EACE,gBAAA;EACA,yBAAA;EACA,mBAAA;AP8oBF;;AO3oBA;EACE,WAAA;EACA,yBAAA;EACA,eAAA;AP8oBF;AO5oBE;;EAEE,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,mBAAA;AP8oBJ;AO3oBE;EACE,mBAAA;EACA,cAr0Be;EAs0Bf,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,gBAAA;EACA,MAAA;AP6oBJ;AO1oBE;EACE,mBAAA;AP4oBJ;AOzoBE;EACE,mBAAA;AP2oBJ;;AOvoBA;EACE,kBAAA;EACA,kBAAA;EACA,cA11BiB;APo+CnB;AOxoBE;EACE,gBAAA;EACA,eAAA;AP0oBJ;AOvoBE;EACE,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,mBAAA;EACA,mBAAA;APyoBJ;;AOpoBA;EACE,YAAA;EACA,eAAA;APuoBF;AOroBE;EACE,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,iCAAA;APuoBJ;AOpoBE;EACE,aAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;APsoBJ;AOnoBE;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAx4BY;EAy4BZ,cAv4BS;EAw4BT,eAAA;EACA,gBAAA;EACA,YAAA;EACA,0BAAA;EACA,gBAAA;APqoBJ;AOnoBI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAx5Ba;AP6hDnB;AOloBI;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;APooBN;AOjoBI;EACE,cAAA;EACA,eAAA;EACA,oBAAA;APmoBN;AOhoBI;EACE,qBAl7BU;EAm7BV,mBAAA;EACA,cAp7BU;APsjDhB;AOhoBM;EACE,mBAv7BQ;EAw7BR,WAAA;APkoBR;AO9nBI;EACE,qBA37BS;EA47BT,mBAAA;APgoBN;AO7nBI;EACE,eAAA;EACA,oBAAA;EACA,cA17Ba;EA27Bb,eAAA;AP+nBN;AO7nBM;EACE,qBAx8BQ;EAy8BR,cAz8BQ;APwkDhB;AO3nBI;EACE,gBAAA;AP6nBN;AOznBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AP2nBJ;AOxnBE;EACE,SAAA;EACA,eAAA;EACA,cAp9Be;AP8kDnB;AOvnBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;APynBJ;AOvnBI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;APynBN;AOrnBE;EACE,eAAA;EACA,cAt+Be;EAu+Bf,mBAAA;EACA,gBAAA;EACA,oBAAA;APunBJ;;AOlnBE;EACE,eAAA;APqnBJ;;AOhnBA;EACE,eAAA;EACA,QAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,aAAA;APmnBF;;AOhnBA;EACE,mBAngCc;EAogCd,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;EACA,6CAAA;APmnBF;AOjnBE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;APmnBJ;AOhnBE;EACE,SAAA;EACA,eAAA;EACA,cAjhCe;EAkhCf,gBAAA;APknBJ;AO/mBE;EACE,gBAAA;EACA,gBAAA;APinBJ;AO/mBI;;EAEE,gBAAA;APinBN;AO9mBI;EACE,eAAA;APgnBN;AO5mBE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;AP8mBJ;AO3mBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AP6mBJ;AO3mBI;EACE,mBAAA;EACA,cA/jCU;AP4qDhB;AO1mBI;EACE,mBAAA;EACA,cAlkCU;AP8qDhB;;AOvmBA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,6CAAA;EACA,aAAA;EACA,6BAAA;AP0mBF;AOxmBE;EACE,mBAvlCY;APisDhB;;AOrmBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,kBAAA;APwmBF;AOtmBE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBA3mCY;EA4mCZ,kBAAA;EACA,mBAAA;EACA,0CAAA;APwmBJ;AOrmBE;EACE,SAAA;EACA,eAAA;EACA,cA1mCe;APitDnB;;AOnmBA;EACE;IACE,yBAAA;EPsmBF;AACF;AOtlBA;EACE;IACE,eAAA;EPwlBF;EOrlBA;IACE,sBAAA;IACA,oBAAA;EPulBF;EOrlBE;IACE,WAAA;EPulBJ;EOnlBA;IACE,sBAAA;EPqlBF;EOnlBE;IACE,WAAA;EPqlBJ;AACF;AOhlBE;EACE,qBApqCY;EAqqCZ,8CAAA;APklBJ;AO/kBE;EACE,mBAAA;APilBJ;AO9kBE;EACE,YAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;APglBJ;AO9kBI;EACE,gBAAA;APglBN;AO5kBE;EACE,2EAAA;EACA,kBAAA;AP8kBJ;AO5kBI;EAJF;IAKI,0BAAA;EP+kBJ;AACF;;AO3kBA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,cA9rCW;EA+rCX,eAAA;AP8kBF;AO5kBE;EACE,WAAA;EACA,YAAA;EACA,qBA7sCY;AP2xDhB;AO3kBE;EAhBF;IAiBI,aAAA;EP8kBF;AACF;;AO3kBA;EACE,iBAAA;EACA,SAAA;EACA,eAAA;EACA,cA/sCiB;AP6xDnB;;AO3kBA;EACE,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;AP8kBF;AO5kBE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,cAnuCe;APizDnB;;AO1kBA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;AP6kBF;AO3kBE;EACE,SAAA;EACA,YAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;EACA,sBAAA;AP6kBJ;AO3kBI;EACE,aAAA;EACA,qBAlwCU;AP+0DhB;;AOvkBE;EACE,2BAAA;AP0kBJ;AOvkBE;EACE,aAAA;EACA,mBAAA;APykBJ;;AOpkBE;EACE,mBAAA;APukBJ;;AOnkBA;EACE,eAAA;EACA,aAAA;EACA,0BAAA;EACA,mBAAA;EACA,uFAAA;APskBF;AOpkBE;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cA1xCe;EA2xCf,yBAAA;EACA,sBAAA;APskBJ;AOnkBE;EACE,kBAAA;EACA,kBAAA;EACA,cAlyCe;EAmyCf,eAAA;APqkBJ;AOlkBE;EACE,UAAA;APokBJ;AOjkBE;EACE,sBAAA;APmkBJ;AOhkBE;EACE,kBAAA;APkkBJ;;AQ53DA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0EAAA;AR+3DF;AQ73DE;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,yCAAA;AR+3DJ;AQ73DI;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AR+3DN;AQ53DI;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,sBAAA;EACA,wDAAA;AR83DN;AQ53DM;EACE,qBAAA;EACA,aAAA;EACA,6CAAA;AR83DR;AQ33DM;EACE,YAAA;EACA,mBAAA;AR63DR;AQz3DI;EACE,cAAA;EACA,gBAAA;EACA,eAAA;AR23DN;AQx3DI;EACE,WAAA;EACA,qDAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AR03DN;AQx3DM;EACE,qDAAA;EACA,2BAAA;AR03DR;AQv3DM;EACE,YAAA;EACA,mBAAA;ARy3DR;AQr3DI;EACE,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,eAAA;EACA,qBAAA;EACA,2BAAA;ARu3DN;AQr3DM;EACE,cAAA;EACA,0BAAA;ARu3DR;;AS78DA;EACE,gBAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,6DAAA;EACA,8CAAA;ATg9DF;AS98DE;EARF;IASI,iBAAA;ETi9DF;AACF;AS/8DE;EACE,aAAA;EACA,0EAAA;EACA,SAAA;EACA,kBAAA;ATi9DJ;AS/8DI;EANF;IAOI,gDAAA;IACA,cAAA;ETk9DJ;AACF;ASh9DI;EAXF;IAYI,0BAAA;IACA,SAAA;ETm9DJ;AACF;ASh9DE;EACE,gBAAA;ATk9DJ;ASh9DI;EAHF;IAII,eAAA;ETm9DJ;AACF;ASh9DE;EACE,aAAA;EACA,2BAAA;EACA,mBAAA;ATk9DJ;ASh9DI;EACE,WAAA;EACA,YAAA;ATk9DN;AS98DE;EACE,cAAA;EACA,eAAA;EACA,iBAAA;ATg9DJ;AS78DE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,cR3DM;AD0gEV;AS78DI;EACE,eAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AT+8DN;AS58DI;;;EAGE,SAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;AT88DN;AS38DI;EACE,2BAAA;AT68DN;AS38DM;EACE,cRhFC;AD6hET;ASz8DI;EACE,aAAA;EACA,2BAAA;EACA,gBAAA;AT28DN;ASv8DE;EACE,SAAA;ATy8DJ;ASv8DI;EACE,kBAAA;ATy8DN;ASr8DE;EACE,gBAAA;EACA,iBAAA;EACA,wCAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;ATu8DJ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap');\n\nhtml {\n    scrollbar-gutter: stable;\n}\n\n@supports not (scrollbar-gutter: stable) {\n    html {\n        overflow-y: scroll;\n    }\n}\n\nbody {\n    padding: 0;\n    margin: 0;\n    font-size: 16px;\n    line-height: 16px;\n    font-weight: 400;\n    font-family: $font-family-base;\n    overflow-x: hidden;\n    // background-color: $light;\n    background: rgb(6,198,222);\n    background: linear-gradient(90deg, rgba(6,198,222,1) 0%, rgba(205,253,254,0.8757878151260504) 0%, rgba(233,242,244,1) 50%);\n    color: $primary;\n}\n\nh1, h2, h3, h4, h5, h6, p {\n    margin: 0;\n    padding: 0;\n    font-size: 16px;\n    line-height: 24px;\n}\n\n* {\n    box-sizing: border-box ;\n}\n\nimg {\n    max-width: 100%;\n    height: auto;\n}\n\ninput, button {\n    font-family: $font-family-base;\n    border: none;\n    background: none;\n    outline: none;\n    color: $primary;\n    font-size: 16px;\n}\n\na {\n    color: $primary;\n    text-decoration: none;\n}\n\nsection {\n    position: relative;\n    z-index: 1;\n}\n\nul, li {\n    padding: 0;\n    margin: 0;\n    list-style: none;\n}\n\n.App {\n    min-height: 100vh;\n    display: flex;\n    flex-direction: column;\n}\n\n.container {\n    max-width: 1220px;\n    margin: 0 auto;\n    padding: 0 10px;\n}\n\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\ninput[type=\"number\"] {\n    -moz-appearance: textfield;\n}\n\nh2 {\n    color: $primary;\n    font-size: 24px;\n    font-weight: 700;\n    text-transform:  uppercase;\n}","@import url(\"https://fonts.googleapis.com/css2?family=PT+Sans:ital,wght@0,400;0,700;1,400;1,700&display=swap\");\nhtml {\n  scrollbar-gutter: stable;\n}\n\n@supports not (scrollbar-gutter: stable) {\n  html {\n    overflow-y: scroll;\n  }\n}\nbody {\n  padding: 0;\n  margin: 0;\n  font-size: 16px;\n  line-height: 16px;\n  font-weight: 400;\n  font-family: \"PT Sans\", Roboto, Arial, sans-serif;\n  overflow-x: hidden;\n  background: rgb(6, 198, 222);\n  background: linear-gradient(90deg, rgb(6, 198, 222) 0%, rgba(205, 253, 254, 0.8757878151) 0%, rgb(233, 242, 244) 50%);\n  color: #010101;\n}\n\nh1, h2, h3, h4, h5, h6, p {\n  margin: 0;\n  padding: 0;\n  font-size: 16px;\n  line-height: 24px;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nimg {\n  max-width: 100%;\n  height: auto;\n}\n\ninput, button {\n  font-family: \"PT Sans\", Roboto, Arial, sans-serif;\n  border: none;\n  background: none;\n  outline: none;\n  color: #010101;\n  font-size: 16px;\n}\n\na {\n  color: #010101;\n  text-decoration: none;\n}\n\nsection {\n  position: relative;\n  z-index: 1;\n}\n\nul, li {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n}\n\n.App {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.container {\n  max-width: 1220px;\n  margin: 0 auto;\n  padding: 0 10px;\n}\n\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\nh2 {\n  color: #010101;\n  font-size: 24px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.header {\n  z-index: 10;\n  position: relative;\n}\n@media (max-width: 1024px) {\n  .header {\n    position: relative;\n  }\n}\n\nheader {\n  padding-top: 20px;\n  display: grid;\n  grid-template-columns: 1fr max-content 1fr;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 2px solid #2ccaf1;\n  padding-bottom: 15px;\n}\n@media (max-width: 1024px) {\n  header {\n    display: flex;\n    justify-content: space-between;\n    padding: 15px;\n  }\n}\n@media (max-width: 480px) {\n  header .logo {\n    width: 32px;\n  }\n}\nheader .menu {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  column-gap: 24px;\n}\n@media (max-width: 1024px) {\n  header .menu.desktop-menu {\n    display: none;\n  }\n}\n@media (max-width: 1024px) {\n  header .menu {\n    display: none;\n    position: absolute;\n    top: 100%;\n    left: 0;\n    width: 100%;\n    background: rgba(255, 255, 255, 0.95);\n    backdrop-filter: blur(10px);\n    flex-direction: column;\n    align-items: center;\n    padding: 25px 0;\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n    border-bottom-left-radius: 15px;\n    border-bottom-right-radius: 15px;\n    z-index: 50;\n  }\n  header .menu.active {\n    display: flex;\n    animation: slideDown 0.3s ease forwards;\n  }\n  @keyframes slideDown {\n    0% {\n      transform: translateY(-20px);\n      opacity: 0;\n    }\n    100% {\n      transform: translateY(0);\n      opacity: 1;\n    }\n  }\n}\n@media (max-width: 1024px) and (max-width: 480px) {\n  header .menu {\n    padding: 20px 0;\n  }\n}\nheader .menu-item {\n  margin-bottom: 15px;\n  position: relative;\n}\nheader .menu-item:after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 2px;\n  bottom: -2px;\n  left: 0;\n  background: #2ccaf1;\n  transition: width 0.3s ease;\n}\nheader .menu-item:hover:after {\n  width: 100%;\n}\nheader .menu-item a {\n  font-size: 20px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n  display: inline-block;\n  position: relative;\n  padding: 5px 10px;\n}\nheader .menu-item a:hover {\n  color: #2ccaf1;\n}\nheader .menu-item a:focus {\n  outline: none;\n}\nheader .burger {\n  display: none !important;\n  cursor: pointer;\n  z-index: 100;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background-color: rgba(255, 255, 255, 0.1);\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n  padding: 8px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  transition: all 0.3s ease;\n}\n@media (max-width: 1024px) {\n  header .burger {\n    display: flex !important;\n  }\n}\nheader .burger:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\nheader .burger span {\n  display: block;\n  width: 25px;\n  height: 2.5px;\n  background: #010101;\n  margin: 2.5px 0;\n  border-radius: 4px;\n  transition: all 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6);\n}\nheader .burger.active span {\n  background: #2ccaf1;\n}\nheader .burger.active span:nth-child(1) {\n  transform: rotate(45deg) translate(5px, 5px);\n}\nheader .burger.active span:nth-child(2) {\n  opacity: 0;\n  transform: translateX(-10px);\n}\nheader .burger.active span:nth-child(3) {\n  transform: rotate(-45deg) translate(5px, -5px);\n}\n\n.socials {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  column-gap: 10px;\n  justify-content: flex-end;\n}\n@media (max-width: 1024px) {\n  .socials {\n    display: none;\n  }\n}\n.socials svg {\n  fill: #010101;\n  width: 35px;\n  height: 26px;\n  transition: all 0.4s ease;\n}\n.socials svg.icon-rmiac18 {\n  width: 30px;\n  height: 34px;\n  overflow: visible;\n}\n.socials-item:hover svg {\n  fill: #2ccaf1;\n  transform: scale(1.1);\n}\n\n.promo-title {\n  text-align: center;\n  padding: 30px 0;\n  font-size: 25px;\n  font-weight: 700;\n  line-height: 1.35;\n}\n.promo-box {\n  margin-bottom: 10px;\n}\n.homepage-intro {\n  padding: 12px 0 8px;\n}\n.homepage-intro .promo-title {\n  padding-bottom: 12px;\n}\n\n.homepage-intro-download {\n  display: flex;\n  justify-content: center;\n  margin: 0 auto 14px;\n}\n.homepage-intro-download__link {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  border-radius: 999px;\n  background: rgba(26, 94, 201, 0.08);\n  color: #1a5ec9;\n  font-size: 15px;\n  font-weight: 600;\n  text-decoration: none;\n  word-break: break-word;\n  transition: background 0.15s ease, opacity 0.15s ease;\n}\n.homepage-intro-download__link:hover {\n  background: rgba(26, 94, 201, 0.16);\n  opacity: 0.95;\n}\n.homepage-intro-download__link:focus-visible {\n  outline: 2px solid #1a5ec9;\n  outline-offset: 2px;\n}\n.homepage-intro-download__link span {\n  word-break: break-word;\n}\n@media (max-width: 768px) {\n  .homepage-intro-download__link {\n    font-size: 14px;\n    padding: 7px 14px;\n  }\n}\n\n.promo-highlight {\n  display: flex;\n  justify-content: center;\n  align-items: baseline;\n  flex-wrap: wrap;\n  gap: 10px 18px;\n  max-width: 760px;\n  margin: 0 auto 28px;\n  padding: 0;\n  background: none;\n  box-shadow: none;\n  text-align: center;\n}\n.promo-highlight__time {\n  font-size: 18px;\n  font-weight: 700;\n  color: #1a5ec9;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n}\n.promo-highlight__event {\n  font-size: 18px;\n  line-height: 1.4;\n  color: #010101;\n}\n@media (max-width: 768px) {\n  .promo-highlight {\n    margin-bottom: 20px;\n  }\n  .promo-highlight__time, .promo-highlight__event {\n    font-size: 16px;\n  }\n}\n\n.table-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.table-section .table-container {\n  width: 100%;\n  max-width: 1200px;\n  background: #fff;\n  border-radius: 15px;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  animation: fadeIn 1s ease-in-out;\n  margin-bottom: 20px;\n}\n.table-section .table-container .styled-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-family: \"PT Sans\", Roboto, Arial, sans-serif;\n}\n.table-section .table-container .styled-table th, .table-section .table-container .styled-table td {\n  padding: 15px 20px;\n  text-align: left;\n}\n@media (max-width: 768px) {\n  .table-section .table-container .styled-table th, .table-section .table-container .styled-table td {\n    padding: 10px 10px;\n    font-size: 15px;\n  }\n}\n.table-section .table-container .styled-table th {\n  background: linear-gradient(135deg, #53dde7, #2575fc);\n  color: #fff;\n  font-weight: 600;\n  text-transform: uppercase;\n  font-size: 14px;\n  letter-spacing: 1px;\n  min-width: 150px;\n}\n@media (max-width: 768px) {\n  .table-section .table-container .styled-table th {\n    font-size: 10px;\n  }\n}\n@media (max-width: 600px) {\n  .table-section .table-container .styled-table th {\n    min-width: auto;\n  }\n}\n@media (max-width: 600px) {\n  .table-section .table-container .styled-table th:last-child {\n    display: none;\n  }\n}\n.table-section .table-container .styled-table td {\n  background: #fff;\n  color: #333;\n  border-bottom: 1px solid #e0e0e0;\n  transition: all 0.3s ease;\n}\n@media (max-width: 400px) {\n  .table-section .table-container .styled-table td {\n    font-size: 14px !important;\n  }\n}\n@media (max-width: 600px) {\n  .table-section .table-container .styled-table td:last-child {\n    display: none;\n  }\n}\n.table-section .table-container .styled-table tr:hover td {\n  background: #75d0e0;\n  transform: scale(1.02);\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n}\n.table-section .table-container .styled-table tr.is-highlighted td {\n  font-size: 18px;\n  font-weight: 700;\n}\n.table-section .table-container .styled-table tr:last-child td {\n  border-bottom: none;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.form {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(2px);\n  padding: max(12px, env(safe-area-inset-top)) max(12px, env(safe-area-inset-right)) max(12px, env(safe-area-inset-bottom)) max(12px, env(safe-area-inset-left));\n}\n@media (min-width: 768px) {\n  .form {\n    padding: 24px 16px;\n  }\n}\n\n.form-container {\n  position: relative;\n  width: 100%;\n  max-width: 640px;\n  margin: auto;\n  flex-shrink: 0;\n}\n.form-container .btn-close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 3;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  min-width: 36px;\n  min-height: 36px;\n  padding: 0;\n  margin: 0;\n  border: none;\n  border-left: 1px solid rgba(1, 1, 1, 0.08);\n  border-bottom: 1px solid rgba(1, 1, 1, 0.08);\n  border-radius: 0 16px 0 10px;\n  background: rgba(255, 255, 255, 0.98);\n  color: #010101;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background-color 0.2s ease, color 0.2s ease;\n}\n.form-container .btn-close:hover {\n  background: #ffffff;\n  color: #2ccaf1;\n}\n.form-container .btn-close svg {\n  width: 18px;\n  height: 18px;\n  display: block;\n}\n\n.form-content,\n.form-container .form-title-completed {\n  position: relative;\n  width: 100%;\n  border-radius: 16px;\n  background-color: #ffffff;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.9);\n}\n\n.form-content {\n  padding: 20px 20px 24px;\n}\n\n.form-loading {\n  margin: 0 0 16px;\n  font-size: 15px;\n  color: #6b7280;\n}\n\n.form-container .form-title-completed {\n  padding: 20px 48px 32px 24px;\n  text-align: center;\n  font-size: clamp(18px, 4vw, 22px);\n  font-weight: 600;\n  line-height: 1.4;\n  color: #010101;\n}\n\n.form-group {\n  margin-bottom: 16px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: #010101;\n}\n\n.required-mark {\n  margin-left: 2px;\n  color: #e53935;\n  font-weight: 600;\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  min-height: 44px;\n  padding: 10px 12px;\n  box-sizing: border-box;\n  border: 1px solid rgba(44, 202, 241, 0.45);\n  border-radius: 10px;\n  font-size: 16px;\n  line-height: 1.2;\n  color: #010101;\n  background-color: #ffffff;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #2ccaf1;\n  box-shadow: 0 0 0 3px rgba(44, 202, 241, 0.2);\n}\n\n.form-group select {\n  appearance: none;\n  padding-right: 36px;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23010101' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 16px;\n  cursor: pointer;\n}\n\n.form-consents {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 8px 0 20px;\n}\n\n.form-checkbox {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 0;\n}\n.form-checkbox input[type=checkbox] {\n  width: 18px;\n  height: 18px;\n  margin-top: 2px;\n  flex-shrink: 0;\n  cursor: pointer;\n}\n.form-checkbox .privacy-link {\n  display: inline-flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 14px;\n  line-height: 1.4;\n  color: #2ccaf1;\n  text-decoration: underline;\n  word-break: break-word;\n}\n.form-checkbox .privacy-link:hover {\n  opacity: 0.85;\n}\n\n.error {\n  display: block;\n  margin-top: 4px;\n  font-size: 13px;\n  line-height: 1.3;\n  color: #e53935;\n}\n\nbutton[type=submit] {\n  width: 100%;\n  min-height: 48px;\n  padding: 12px 16px;\n  border: none;\n  border-radius: 10px;\n  background-color: #2ccaf1;\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba(44, 202, 241, 0.35);\n  transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;\n}\nbutton[type=submit]:hover:not(:disabled) {\n  background-color: rgb(15.8293333333, 194.4746666667, 238.5706666667);\n  box-shadow: 0 6px 16px rgba(44, 202, 241, 0.4);\n}\nbutton[type=submit]:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.popup {\n  position: fixed;\n  inset: 0;\n  z-index: 1100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background-color: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(3px);\n}\n\n.popup-content {\n  position: relative;\n  width: min(100%, 400px);\n  padding: 32px 24px 24px;\n  border-radius: 12px;\n  background-color: #ffffff;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);\n  text-align: center;\n}\n.popup-content p {\n  margin-top: 12px;\n  font-size: 16px;\n  line-height: 1.5;\n  color: #010101;\n}\n\n.close {\n  position: absolute;\n  top: 8px;\n  right: 12px;\n  font-size: 28px;\n  line-height: 1;\n  color: #888;\n  cursor: pointer;\n}\n.close:hover {\n  color: #010101;\n}\n\n@media (max-width: 768px) {\n  .form-content {\n    padding: 18px 16px 20px;\n    border-radius: 14px;\n  }\n  .form-container .form-title-completed {\n    padding: 18px 44px 28px 20px;\n  }\n  .form-group {\n    margin-bottom: 12px;\n  }\n}\n@media (max-width: 480px) {\n  .form {\n    padding: max(8px, env(safe-area-inset-top)) max(8px, env(safe-area-inset-right)) max(8px, env(safe-area-inset-bottom)) max(8px, env(safe-area-inset-left));\n  }\n  .form-content {\n    padding: 16px 14px 18px;\n    border-radius: 12px;\n  }\n  .form-container .btn-close {\n    border-radius: 0 12px 0 8px;\n    width: 34px;\n    height: 34px;\n    min-width: 34px;\n    min-height: 34px;\n  }\n  .form-container .btn-close svg {\n    width: 16px;\n    height: 16px;\n  }\n  .form-group label {\n    font-size: 13px;\n  }\n  .form-checkbox .privacy-link {\n    font-size: 13px;\n  }\n  button[type=submit] {\n    min-height: 44px;\n  }\n}\n.App--admin {\n  background: #eef1f6;\n  min-height: 100vh;\n  width: 100%;\n  align-items: stretch;\n}\n.App--admin > * {\n  width: 100%;\n  min-width: 0;\n}\n\n.admin-page, .admin-panel {\n  width: 100%;\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 24px 20px 48px;\n  box-sizing: border-box;\n  min-width: 0;\n  font-family: \"PT Sans\", Roboto, Arial, sans-serif;\n  color: #1f2937;\n}\n@media (max-width: 768px) {\n  .admin-page, .admin-panel {\n    padding: 16px 12px 32px;\n  }\n}\n\n.admin-topbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n}\n.admin-topbar__brand h1 {\n  margin: 0 0 4px;\n  font-size: 26px;\n  font-weight: 700;\n  letter-spacing: -0.02em;\n  color: #1f2937;\n}\n.admin-topbar__brand p {\n  margin: 0;\n  font-size: 14px;\n  color: #6b7280;\n}\n.admin-topbar__actions {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.admin-link-btn {\n  display: inline-flex;\n  align-items: center;\n  padding: 9px 16px;\n  border-radius: 8px;\n  border: 1px solid #e3e8ef;\n  background: #ffffff;\n  color: #1f2937;\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: none;\n  transition: all 0.15s ease;\n}\n.admin-link-btn:hover {\n  border-color: #2575fc;\n  color: #2575fc;\n  background: #f5f9ff;\n}\n\n.admin-logout-btn {\n  padding: 9px 16px;\n  border-radius: 8px;\n  border: 1px solid #e3e8ef;\n  background: #ffffff;\n  color: #6b7280;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n}\n.admin-logout-btn:hover {\n  border-color: #de350b;\n  color: #de350b;\n  background: #fff5f5;\n}\n\n.admin-stats {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 20px;\n  width: 100%;\n}\n@media (max-width: 768px) {\n  .admin-stats {\n    grid-template-columns: 1fr;\n  }\n}\n\n.admin-stat-card {\n  background: #ffffff;\n  border: 1px solid #e3e8ef;\n  border-radius: 12px;\n  padding: 16px 18px;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08), 0 4px 16px rgba(15, 23, 42, 0.04);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-height: 132px;\n}\n.admin-stat-card__label {\n  font-size: 13px;\n  color: #6b7280;\n  font-weight: 500;\n}\n.admin-stat-card__value {\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 1;\n  color: #1f2937;\n}\n.admin-stat-card__summary {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #6b7280;\n}\n.admin-stat-card__hint {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #6b7280;\n}\n.admin-stat-card__breakdown {\n  margin: 4px 0 0;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.admin-stat-card__breakdown li {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 10px;\n  font-size: 12px;\n  line-height: 1.35;\n}\n.admin-stat-card__breakdown-label {\n  color: #1f2937;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.admin-stat-card__breakdown-value {\n  flex-shrink: 0;\n  font-weight: 700;\n  color: #1a5ec9;\n}\n.admin-stat-card--participants .admin-stat-card__value {\n  color: #1a5ec9;\n}\n.admin-stat-card--programs .admin-stat-card__value {\n  color: #6a11cb;\n}\n\n.admin-status-badge {\n  display: inline-flex;\n  align-items: center;\n  width: fit-content;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 600;\n}\n.admin-status-badge.is-open {\n  background: #e3fcef;\n  color: #006644;\n}\n.admin-status-badge.is-closed {\n  background: #ffebe6;\n  color: #bf2600;\n}\n\n.admin-section-card {\n  background: #ffffff;\n  border: 1px solid #e3e8ef;\n  border-radius: 12px;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08), 0 4px 16px rgba(15, 23, 42, 0.04);\n  margin-bottom: 16px;\n  overflow: hidden;\n  width: 100%;\n  min-width: 0;\n}\n.admin-section-card--highlight {\n  border-color: #c8dafc;\n  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);\n}\n.admin-section-card__header {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 18px 20px;\n  border: none;\n  background: transparent;\n  text-align: left;\n  transition: background 0.15s ease;\n}\n.admin-section-card__header:hover {\n  background: #f8fafc;\n}\n.admin-section-card__header.is-open {\n  border-bottom: 1px solid #e3e8ef;\n}\n@media (max-width: 768px) {\n  .admin-section-card__header {\n    flex-wrap: wrap;\n  }\n  .admin-section-card__header .admin-section-card__toggle {\n    flex: 1 1 calc(100% - 48px);\n  }\n  .admin-section-card__header .admin-section-card__actions {\n    order: 3;\n    width: 100%;\n  }\n}\n.admin-section-card__toggle {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  padding: 0;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  text-align: left;\n  color: inherit;\n  font: inherit;\n}\n.admin-section-card__actions {\n  flex-shrink: 0;\n}\n.admin-section-card__programs-toggle {\n  padding: 7px 12px;\n  font-size: 13px;\n}\n.admin-section-card__chevron-btn {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0;\n  border: none;\n  border-radius: 8px;\n  background: transparent;\n  cursor: pointer;\n}\n.admin-section-card__chevron-btn:hover {\n  background: #eef2f7;\n}\n.admin-section-card__collapse {\n  overflow: hidden;\n  will-change: height, opacity;\n}\n.admin-section-card__title-wrap h3 {\n  margin: 0 0 2px;\n  font-size: 17px;\n  font-weight: 600;\n  color: #1f2937;\n}\n.admin-section-card__title-wrap p {\n  margin: 0;\n  font-size: 13px;\n  color: #6b7280;\n}\n.admin-section-card__chevron {\n  flex-shrink: 0;\n  width: 10px;\n  height: 10px;\n  border-right: 2px solid #6b7280;\n  border-bottom: 2px solid #6b7280;\n  transform: rotate(45deg);\n  transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), margin-top 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.admin-section-card__chevron.is-open {\n  transform: rotate(-135deg);\n  margin-top: 4px;\n}\n.admin-section-card__body {\n  padding: 20px;\n  overflow: hidden;\n  min-width: 0;\n  max-width: 100%;\n}\n.admin-section-card__body--flat {\n  padding: 0;\n}\n\n.registration-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  padding: 20px 24px;\n  flex-wrap: wrap;\n  width: 100%;\n  box-sizing: border-box;\n}\n.registration-controls__info {\n  flex: 1;\n  min-width: 200px;\n}\n.registration-controls__info h2 {\n  margin: 0 0 6px;\n  font-size: 16px;\n  font-weight: 600;\n}\n.registration-controls__info p {\n  margin: 0;\n  font-size: 14px;\n  color: #6b7280;\n  line-height: 1.45;\n}\n.registration-controls button {\n  flex-shrink: 0;\n}\n\n.admin-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 10px 16px;\n  border-radius: 8px;\n  border: none;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n}\n.admin-action-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n.admin-action-btn--primary {\n  background: linear-gradient(135deg, #2575fc, #6a11cb);\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(37, 117, 252, 0.3);\n}\n.admin-action-btn--primary:hover:not(:disabled) {\n  filter: brightness(1.05);\n  transform: translateY(-1px);\n}\n.admin-action-btn--secondary {\n  background: #f3f4f6;\n  color: #1f2937;\n}\n.admin-action-btn--secondary:hover:not(:disabled) {\n  background: #e5e7eb;\n}\n.admin-action-btn--success {\n  background: #22a06b;\n  color: #fff;\n}\n.admin-action-btn--success:hover:not(:disabled) {\n  filter: brightness(1.05);\n}\n.admin-action-btn--danger {\n  background: #de350b;\n  color: #fff;\n}\n.admin-action-btn--danger:hover:not(:disabled) {\n  filter: brightness(1.05);\n}\n.admin-action-btn--ghost-danger {\n  background: transparent;\n  border: 1px solid #ffb3a8;\n  color: #de350b;\n}\n.admin-action-btn--ghost-danger:hover:not(:disabled) {\n  background: #fff5f5;\n}\n\n.complete-registration-btn.clicked,\n.reopen-registration-btn.clicked {\n  opacity: 0.85;\n}\n\n.admin-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n}\n.admin-toolbar--compact {\n  margin-top: 4px;\n}\n.admin-toolbar__count {\n  margin-left: auto;\n  font-size: 13px;\n  color: #6b7280;\n  font-weight: 600;\n}\n\n.admin-form {\n  background: #f8fafc;\n  border: 1px solid #e3e8ef;\n  border-radius: 10px;\n  padding: 20px;\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.admin-form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n  margin-bottom: 20px;\n}\n@media (max-width: 768px) {\n  .admin-form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.admin-field--wide {\n  grid-column: 1/-1;\n}\n\n.program-title-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n.program-title-heading > label[for=program-title] {\n  margin: 0;\n}\n.program-title-heading__controls {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  flex-wrap: wrap;\n}\n\n.admin-inline-check {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1f2937;\n  cursor: pointer;\n  user-select: none;\n}\n.admin-inline-check input {\n  width: 16px;\n  height: 16px;\n  margin: 0;\n  accent-color: #2575fc;\n  cursor: pointer;\n}\n\n.program-title-size {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: #6b7280;\n}\n.program-title-size select {\n  width: auto;\n  min-width: 150px;\n  padding: 6px 10px;\n  font-size: 13px;\n}\n\n.admin-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n.admin-field label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #6b7280;\n}\n.admin-field .admin-field-hint {\n  font-size: 12px;\n  line-height: 1.4;\n  color: #6b7280;\n}\n.admin-field .admin-field-hint code {\n  padding: 1px 5px;\n  border-radius: 4px;\n  background: rgba(31, 41, 55, 0.06);\n  font-size: 12px;\n}\n.admin-field input,\n.admin-field textarea,\n.admin-field select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #e3e8ef;\n  border-radius: 8px;\n  font-size: 15px;\n  font-family: inherit;\n  color: #1f2937;\n  background: #ffffff;\n  box-sizing: border-box;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n.admin-field input::placeholder,\n.admin-field textarea::placeholder,\n.admin-field select::placeholder {\n  color: #9ca3af;\n}\n.admin-field input:focus,\n.admin-field textarea:focus,\n.admin-field select:focus {\n  outline: none;\n  border-color: #2575fc;\n  box-shadow: 0 0 0 3px rgba(37, 117, 252, 0.12);\n}\n.admin-field input:disabled,\n.admin-field textarea:disabled,\n.admin-field select:disabled {\n  background: #f3f4f6;\n  color: #6b7280;\n}\n.admin-field textarea {\n  resize: vertical;\n  min-height: 72px;\n}\n\n.admin-form-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid #e3e8ef;\n  flex-wrap: wrap;\n}\n@media (max-width: 768px) {\n  .admin-form-footer {\n    flex-direction: column;\n  }\n  .admin-form-footer .admin-action-btn {\n    width: 100%;\n  }\n}\n\n.table-row {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 12px;\n  padding: 14px;\n  background: #ffffff;\n  border: 1px solid #e3e8ef;\n  border-radius: 10px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  min-width: 0;\n  max-width: 100%;\n}\n.table-row:hover {\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);\n}\n.table-row.is-selected {\n  border-color: #2575fc;\n  background: #f5f9ff;\n}\n@media (max-width: 768px) {\n  .table-row {\n    flex-direction: column;\n  }\n}\n.table-row__number {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f3f4f6;\n  border-radius: 6px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #6b7280;\n  margin-top: 24px;\n}\n@media (max-width: 768px) {\n  .table-row__number {\n    margin-top: 0;\n  }\n}\n.table-row__fields {\n  flex: 1;\n  min-width: 0;\n  display: grid;\n  grid-template-columns: minmax(100px, 140px) minmax(0, 1fr) minmax(0, 1fr);\n  gap: 12px;\n}\n@media (max-width: 1024px) {\n  .table-row__fields {\n    grid-template-columns: 1fr;\n  }\n}\n\n.row-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex-shrink: 0;\n  min-width: 110px;\n}\n@media (max-width: 768px) {\n  .row-actions {\n    flex-direction: row;\n    flex-wrap: wrap;\n    min-width: 0;\n  }\n}\n\n.row-action-btn {\n  padding: 7px 10px;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: filter 0.15s ease;\n}\n.row-action-btn--warn {\n  background: #fff7e6;\n  color: #b76e00;\n}\n.row-action-btn--danger {\n  background: #ffebe6;\n  color: #de350b;\n}\n.row-action-btn--select {\n  background: #e6f4ff;\n  color: #0958d9;\n}\n.row-action-btn--select.is-active {\n  background: #2575fc;\n  color: #fff;\n}\n.row-action-btn:hover {\n  filter: brightness(0.96);\n}\n\n.registrations-list-wrap {\n  margin-top: 4px;\n}\n\n.registration-forum-tabs-scroll {\n  overflow-x: auto;\n  margin: 0 0 16px;\n  padding-bottom: 4px;\n  max-width: 100%;\n  -webkit-overflow-scrolling: touch;\n}\n\n.registration-forum-tabs {\n  display: flex;\n  gap: 8px;\n  width: max-content;\n  max-width: none;\n}\n\n.registration-forum-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  border: 1px solid #e3e8ef;\n  border-radius: 999px;\n  background: #fff;\n  color: #1f2937;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n  white-space: nowrap;\n}\n.registration-forum-tab__label {\n  max-width: 260px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.registration-forum-tab__count {\n  min-width: 22px;\n  padding: 2px 7px;\n  border-radius: 999px;\n  background: #eef2f7;\n  color: #6b7280;\n  font-size: 12px;\n  font-weight: 700;\n  text-align: center;\n}\n.registration-forum-tab.is-active {\n  border-color: #2575fc;\n  background: #e8f1ff;\n  color: #1a5ec9;\n}\n.registration-forum-tab.is-active .registration-forum-tab__count {\n  background: #2575fc;\n  color: #fff;\n}\n\n.registration-forum-panel {\n  min-width: 0;\n}\n\n.registrations-list {\n  overflow-x: auto;\n  border: 1px solid #e3e8ef;\n  border-radius: 10px;\n}\n\n.registrations-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n.registrations-table th,\n.registrations-table td {\n  padding: 11px 14px;\n  text-align: left;\n  border-bottom: 1px solid #e3e8ef;\n  white-space: nowrap;\n}\n.registrations-table th {\n  background: #f8fafc;\n  color: #6b7280;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n  position: sticky;\n  top: 0;\n}\n.registrations-table tbody tr:hover td {\n  background: #f8fafc;\n}\n.registrations-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.admin-empty-state {\n  text-align: center;\n  padding: 32px 20px;\n  color: #6b7280;\n}\n.admin-empty-state p {\n  margin: 0 0 12px;\n  font-size: 15px;\n}\n.admin-empty-state--compact {\n  padding: 24px 16px;\n  background: #f8fafc;\n  border: 1px dashed #e3e8ef;\n  border-radius: 10px;\n  margin-bottom: 12px;\n}\n\n.program-documents-editor {\n  min-width: 0;\n  max-width: 100%;\n}\n.program-documents-editor .program-tabs-scroll {\n  overflow-x: auto;\n  margin-bottom: 16px;\n  padding-bottom: 4px;\n  max-width: 100%;\n  -webkit-overflow-scrolling: touch;\n}\n.program-documents-editor .program-tabs {\n  display: flex;\n  gap: 8px;\n  width: max-content;\n  max-width: none;\n}\n.program-documents-editor .program-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  border: 1px solid #e3e8ef;\n  border-radius: 8px;\n  background: #ffffff;\n  color: #1f2937;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: grab;\n  transition: all 0.15s ease;\n  max-width: 240px;\n}\n.program-documents-editor .program-tab__index {\n  flex-shrink: 0;\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #f3f4f6;\n  border-radius: 4px;\n  font-size: 11px;\n  font-weight: 700;\n  color: #6b7280;\n}\n.program-documents-editor .program-tab__label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.program-documents-editor .program-tab__drag {\n  color: #c4c9d2;\n  font-size: 11px;\n  letter-spacing: -2px;\n}\n.program-documents-editor .program-tab.is-active {\n  border-color: #2575fc;\n  background: #f0f7ff;\n  color: #2575fc;\n}\n.program-documents-editor .program-tab.is-active .program-tab__index {\n  background: #2575fc;\n  color: #fff;\n}\n.program-documents-editor .program-tab.is-drag-over {\n  border-color: #6a11cb;\n  background: #f8f4ff;\n}\n.program-documents-editor .program-tab--add {\n  cursor: pointer;\n  border-style: dashed;\n  color: #6b7280;\n  max-width: none;\n}\n.program-documents-editor .program-tab--add:hover {\n  border-color: #2575fc;\n  color: #2575fc;\n}\n.program-documents-editor .program-tab:active {\n  cursor: grabbing;\n}\n.program-documents-editor .program-editor-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 16px;\n  flex-wrap: wrap;\n}\n.program-documents-editor .program-editor-hint {\n  margin: 0;\n  font-size: 13px;\n  color: #6b7280;\n}\n.program-documents-editor .program-table-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n.program-documents-editor .program-table-header h4 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 600;\n}\n.program-documents-editor .program-table-count {\n  font-size: 12px;\n  color: #6b7280;\n  background: #f3f4f6;\n  padding: 3px 8px;\n  border-radius: 999px;\n}\n\n.program-block + .program-block {\n  margin-top: 8px;\n}\n\n.admin-modal-overlay, .popup-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.admin-modal, .popup-content {\n  background: #ffffff;\n  border-radius: 16px;\n  padding: 28px 32px;\n  max-width: 360px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.2);\n}\n.admin-modal h3, .popup-content h3 {\n  margin: 12px 0 8px;\n  font-size: 18px;\n  font-weight: 700;\n}\n.admin-modal p, .popup-content p {\n  margin: 0;\n  font-size: 14px;\n  color: #6b7280;\n  line-height: 1.5;\n}\n.admin-modal--confirm {\n  max-width: 420px;\n  text-align: left;\n}\n.admin-modal--confirm h3,\n.admin-modal--confirm p {\n  text-align: left;\n}\n.admin-modal--confirm .admin-modal__icon {\n  margin: 0 0 4px;\n}\n.admin-modal__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 20px;\n  justify-content: flex-end;\n}\n.admin-modal__icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto;\n  font-size: 22px;\n  font-weight: 700;\n}\n.admin-modal__icon--success {\n  background: #e3fcef;\n  color: #22a06b;\n}\n.admin-modal__icon--warning {\n  background: #fff7e6;\n  color: #ff991f;\n}\n\n.admin-toast {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  padding: 12px 18px;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);\n  z-index: 9999;\n  max-width: calc(100vw - 40px);\n}\n.admin-toast--success {\n  background: #22a06b;\n}\n\n.admin-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  padding: 40px 20px;\n}\n.admin-loading .loading-spinner {\n  width: 44px;\n  height: 44px;\n  border: 3px solid #e5e7eb;\n  border-top-color: #2575fc;\n  border-radius: 50%;\n  margin-bottom: 16px;\n  animation: admin-spin 0.8s linear infinite;\n}\n.admin-loading p {\n  margin: 0;\n  font-size: 15px;\n  color: #6b7280;\n}\n\n@keyframes admin-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n@media (max-width: 768px) {\n  .admin-topbar__brand h1 {\n    font-size: 22px;\n  }\n  .registration-controls {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .registration-controls button {\n    width: 100%;\n  }\n  .admin-toolbar {\n    flex-direction: column;\n  }\n  .admin-toolbar .admin-action-btn {\n    width: 100%;\n  }\n}\n.form-field-row.is-drag-over {\n  border-color: #2575fc;\n  box-shadow: 0 0 0 3px rgba(37, 117, 252, 0.12);\n}\n.form-field-row.is-locked {\n  background: #f8fafc;\n}\n.form-field-row__handle {\n  cursor: grab;\n  user-select: none;\n  letter-spacing: -2px;\n}\n.form-field-row__handle:active {\n  cursor: grabbing;\n}\n.form-field-row__fields {\n  grid-template-columns: minmax(0, 1.4fr) minmax(120px, 160px) minmax(0, 1fr);\n  align-items: start;\n}\n@media (max-width: 1024px) {\n  .form-field-row__fields {\n    grid-template-columns: 1fr;\n  }\n}\n\n.form-field-required {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 22px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1f2937;\n  cursor: pointer;\n}\n.form-field-required input {\n  width: 16px;\n  height: 16px;\n  accent-color: #2575fc;\n}\n@media (max-width: 1024px) {\n  .form-field-required {\n    margin-top: 0;\n  }\n}\n\n.form-field-locked-note {\n  grid-column: 1/-1;\n  margin: 0;\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.form-field-options {\n  grid-column: 1/-1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px;\n  background: #f8fafc;\n  border: 1px dashed #e3e8ef;\n  border-radius: 8px;\n}\n.form-field-options__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #6b7280;\n}\n\n.form-field-option {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n}\n.form-field-option input {\n  flex: 1;\n  min-width: 0;\n  padding: 8px 10px;\n  border: 1px solid #e3e8ef;\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: inherit;\n  box-sizing: border-box;\n}\n.form-field-option input:focus {\n  outline: none;\n  border-color: #2575fc;\n}\n\n.registration-form-editor .admin-form-footer {\n  justify-content: flex-start;\n}\n.registration-form-editor .row-action-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.homepage-intro-editor .program-editor-hint {\n  margin-bottom: 16px;\n}\n\n.homepage-intro-preview {\n  margin-top: 4px;\n  padding: 16px;\n  border: 1px dashed #e3e8ef;\n  border-radius: 12px;\n  background: linear-gradient(90deg, rgba(205, 253, 254, 0.7) 0%, rgb(233, 242, 244) 50%);\n}\n.homepage-intro-preview__label {\n  display: block;\n  margin-bottom: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #6b7280;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.homepage-intro-preview__empty {\n  margin: 12px 0 4px;\n  text-align: center;\n  color: #6b7280;\n  font-size: 14px;\n}\n.homepage-intro-preview .homepage-intro {\n  padding: 0;\n}\n.homepage-intro-preview .promo-title {\n  padding: 16px 8px 10px;\n}\n.homepage-intro-preview .promo-highlight {\n  margin-bottom: 8px;\n}\n\n.admin-login {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  padding: 24px 16px;\n  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);\n}\n.admin-login .admin-login-form {\n  width: 100%;\n  min-width: 280px;\n  max-width: 400px;\n  background: #fff;\n  padding: 32px 28px;\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n}\n.admin-login .admin-login-form h3 {\n  margin: 0 0 24px;\n  color: #333;\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 1.3;\n}\n.admin-login .admin-login-form input {\n  width: 100%;\n  padding: 12px 14px;\n  margin-bottom: 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 16px;\n  box-sizing: border-box;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n.admin-login .admin-login-form input:focus {\n  border-color: #2575fc;\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(37, 117, 252, 0.2);\n}\n.admin-login .admin-login-form input:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n.admin-login .admin-login-form .error {\n  color: #dc3545;\n  margin: 0 0 12px;\n  font-size: 14px;\n}\n.admin-login .admin-login-form button {\n  width: 100%;\n  background: linear-gradient(135deg, #2575fc, #6a11cb);\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n.admin-login .admin-login-form button:hover:not(:disabled) {\n  background: linear-gradient(135deg, #1a5ec9, #5910a8);\n  transform: translateY(-1px);\n}\n.admin-login .admin-login-form button:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n.admin-login .admin-login-form .admin-login-home-link {\n  display: inline-block;\n  margin-top: 16px;\n  color: #666;\n  font-size: 14px;\n  text-decoration: none;\n  transition: color 0.2s ease;\n}\n.admin-login .admin-login-form .admin-login-home-link:hover {\n  color: #2575fc;\n  text-decoration: underline;\n}\n\n.footer {\n  margin-top: auto;\n  padding: 48px 0 20px;\n  position: relative;\n  z-index: 1;\n  background: linear-gradient(135deg, #eefbfe 0%, #e7f4f6 100%);\n  border-top: 1px solid rgba(44, 202, 241, 0.28);\n}\n@media (max-width: 768px) {\n  .footer {\n    padding-top: 36px;\n  }\n}\n.footer-wrapper {\n  display: grid;\n  grid-template-columns: minmax(210px, 1.15fr) repeat(3, minmax(180px, 1fr));\n  gap: 40px;\n  align-items: start;\n}\n@media (max-width: 1024px) {\n  .footer-wrapper {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 36px 48px;\n  }\n}\n@media (max-width: 768px) {\n  .footer-wrapper {\n    grid-template-columns: 1fr;\n    gap: 30px;\n  }\n}\n.footer-brand {\n  max-width: 270px;\n}\n@media (max-width: 768px) {\n  .footer-brand {\n    max-width: none;\n  }\n}\n.footer-logo {\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 18px;\n}\n.footer-logo img {\n  width: 86px;\n  height: auto;\n}\n.footer-description {\n  color: #71848a;\n  font-size: 14px;\n  line-height: 1.25;\n}\n.footer-section {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  color: #010101;\n}\n.footer-section h3 {\n  margin: 0 0 8px;\n  font-size: 20px;\n  line-height: 1.2;\n  font-weight: 700;\n}\n.footer-section p,\n.footer-section address,\n.footer-section a {\n  margin: 0;\n  color: inherit;\n  font-size: 15px;\n  line-height: 1.35;\n  font-style: normal;\n}\n.footer-section a {\n  transition: color 0.2s ease;\n}\n.footer-section a:hover {\n  color: #2ccaf1;\n}\n.footer-section .socials {\n  display: flex;\n  justify-content: flex-start;\n  margin-top: 10px;\n}\n.footer-schedule {\n  gap: 14px;\n}\n.footer-schedule h3 {\n  margin-bottom: 2px;\n}\n.footer-bottom {\n  margin-top: 38px;\n  padding-top: 18px;\n  border-top: 1px solid rgba(1, 1, 1, 0.1);\n  color: #71848a;\n  font-size: 13px;\n  text-align: center;\n}","$primary: #010101;\n$light: #ffffff;\n$action: #2ccaf1;\n$grey: #ffffff80;\n$dark: #1e1e1e;\n$font-family-base: 'PT Sans', Roboto, Arial, sans-serif;\n\n$mobile: 480px;\n$tablet: 768px;\n$laptop: 1024px;\n$desktop: 1200px;",".header {\n  z-index: 10;\n  position: relative;\n\n  @media (max-width: 1024px) {\n    position: relative;\n  }\n}\n\nheader {\n  padding-top: 20px;\n  display: grid;\n  grid-template-columns: 1fr max-content 1fr;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 2px solid $action;\n  padding-bottom: 15px;\n\n  @media (max-width: 1024px) {\n    display: flex;\n    justify-content: space-between;\n    padding: 15px;\n  }\n\n  .logo {\n    @media (max-width: 480px) {\n      width: 32px;\n    }\n  }\n\n  .menu {\n    @include flex;\n    column-gap: 24px;\n\n    &.desktop-menu {\n      @media (max-width: 1024px) {\n        display: none;\n      }\n    }\n\n    @media (max-width: 1024px) {\n      display: none;\n      position: absolute;\n      top: 100%;\n      left: 0;\n      width: 100%;\n      background: rgba(255, 255, 255, 0.95);\n      backdrop-filter: blur(10px);\n      flex-direction: column;\n      align-items: center;\n      padding: 25px 0;\n      box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n      border-bottom-left-radius: 15px;\n      border-bottom-right-radius: 15px;\n      z-index: 50;\n\n      &.active {\n        display: flex;\n        animation: slideDown 0.3s ease forwards;\n      }\n\n      @keyframes slideDown {\n        0% {\n          transform: translateY(-20px);\n          opacity: 0;\n        }\n        100% {\n          transform: translateY(0);\n          opacity: 1;\n        }\n      }\n\n      @media (max-width: 480px) {\n        padding: 20px 0;\n      }\n    }\n\n    &-item {\n      margin-bottom: 15px;\n      position: relative;\n      \n      &:after {\n        content: '';\n        position: absolute;\n        width: 0;\n        height: 2px;\n        bottom: -2px;\n        left: 0;\n        background: $action;\n        transition: width 0.3s ease;\n      }\n      \n      &:hover:after {\n        width: 100%;\n      }\n\n      a {\n        font-size: 20px;\n        font-weight: 500;\n        transition: all 0.3s ease;\n        display: inline-block;\n        position: relative;\n        padding: 5px 10px;\n\n        &:hover {\n          color: $action;\n        }\n\n        &:focus {\n          outline: none;\n        }\n      }\n    }\n  }\n\n  .burger {\n    display: none !important; \n    cursor: pointer;\n    z-index: 100;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background-color: rgba(255, 255, 255, 0.1);\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);\n    padding: 8px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    transition: all 0.3s ease;\n\n    @media (max-width: 1024px) {\n      display: flex !important;\n    }\n\n    &:hover {\n      background-color: rgba(255, 255, 255, 0.2);\n      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n    }\n\n    span {\n      display: block;\n      width: 25px;\n      height: 2.5px;\n      background: $primary;\n      margin: 2.5px 0;\n      border-radius: 4px;\n      transition: all 0.4s cubic-bezier(0.68, -0.6, 0.32, 1.6);\n    }\n\n    &.active {\n      span {\n        background: $action;\n      }\n      \n      span:nth-child(1) {\n        transform: rotate(45deg) translate(5px, 5px);\n      }\n      \n      span:nth-child(2) {\n        opacity: 0;\n        transform: translateX(-10px);\n      }\n      \n      span:nth-child(3) {\n        transform: rotate(-45deg) translate(5px, -5px);\n      }\n    }\n  }\n}\n\n.socials {\n  @include flex;\n  column-gap: 10px;\n  justify-content: flex-end;\n\n  @media (max-width: 1024px) {\n    display: none; // Скрываем иконки на экранах меньше 1024px\n  }\n\n  svg {\n    fill: $primary;\n    width: 35px;\n    height: 26px;\n    transition: all 0.4s ease;\n  }\n\n  svg.icon-rmiac18 {\n    width: 30px;\n    height: 34px;\n    overflow: visible;\n  }\n\n  &-item {\n    &:hover {\n      svg {\n        fill: $action;\n        transform: scale(1.1);\n      }\n    }\n  }\n}","@mixin flex() {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@mixin center() {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}",".promo {\n    &-title {\n        text-align: center;\n        padding: 30px 0;\n        font-size: 25px;\n        font-weight: 700;\n        line-height: 1.35;\n    }\n    &-box {\n        margin-bottom: 10px;\n    }\n    &-data {\n\n    }\n    &-format {\n\n    }\n\n}\n\n.homepage-intro {\n    padding: 12px 0 8px;\n\n    .promo-title {\n        padding-bottom: 12px;\n    }\n}\n\n.homepage-intro-download {\n    display: flex;\n    justify-content: center;\n    margin: 0 auto 14px;\n\n    &__link {\n        display: inline-flex;\n        align-items: center;\n        gap: 8px;\n        padding: 8px 16px;\n        border-radius: 999px;\n        background: rgba(26, 94, 201, 0.08);\n        color: #1a5ec9;\n        font-size: 15px;\n        font-weight: 600;\n        text-decoration: none;\n        word-break: break-word;\n        transition: background 0.15s ease, opacity 0.15s ease;\n\n        &:hover {\n            background: rgba(26, 94, 201, 0.16);\n            opacity: 0.95;\n        }\n\n        &:focus-visible {\n            outline: 2px solid #1a5ec9;\n            outline-offset: 2px;\n        }\n\n        span {\n            word-break: break-word;\n        }\n\n        @media (max-width: $tablet) {\n            font-size: 14px;\n            padding: 7px 14px;\n        }\n    }\n}\n\n.promo-highlight {\n    display: flex;\n    justify-content: center;\n    align-items: baseline;\n    flex-wrap: wrap;\n    gap: 10px 18px;\n    max-width: 760px;\n    margin: 0 auto 28px;\n    padding: 0;\n    background: none;\n    box-shadow: none;\n    text-align: center;\n\n    &__time {\n        font-size: 18px;\n        font-weight: 700;\n        color: #1a5ec9;\n        letter-spacing: 0.02em;\n        white-space: nowrap;\n    }\n\n    &__event {\n        font-size: 18px;\n        line-height: 1.4;\n        color: $primary;\n    }\n\n    @media (max-width: $tablet) {\n        margin-bottom: 20px;\n\n        &__time,\n        &__event {\n            font-size: 16px;\n        }\n    }\n}","// .table {\n//     margin-bottom: 20px;\n// }\n\n// .table {\n//     padding: 20px;\n  \n  \n//     .custom-table {\n//       width: 100%;\n//       border-collapse: collapse;\n//       margin-top: 20px;\n//       background-color: $light;\n  \n//       th, td {\n//         padding: 12px;\n//         text-align: left;\n//         border-bottom: 1px solid #ddd;\n//       }\n  \n//       th {\n//         background-color: #f4f4f4;\n//         font-weight: bold;\n//       }\n  \n//       tr:hover {\n//         background-color: #f9f9f9;\n//       }\n//     }\n//   }\n\n// Основные стили для секции таблицы\n.table-section {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  \n  .table-container {\n    width: 100%;\n    max-width: 1200px;\n    background: #fff;\n    border-radius: 15px;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);\n    overflow: hidden;\n    animation: fadeIn 1s ease-in-out;\n    margin-bottom: 20px;\n\n    .styled-table {\n      width: 100%;\n      border-collapse: collapse;\n      font-family: $font-family-base;\n\n      th, td {\n        padding: 15px 20px;\n        text-align: left;\n\n        @media (max-width: 768px) {\n          padding: 10px 10px;\n          font-size: 15px;\n        }\n      }\n\n      th {\n        background: linear-gradient(135deg, #53dde7, #2575fc);\n        color: #fff;\n        font-weight: 600;\n        text-transform: uppercase;\n        font-size: 14px;\n        letter-spacing: 1px;\n        min-width: 150px;\n        @media (max-width: 768px) {\n          font-size: 10px;\n        }\n        @media (max-width: 600px) {\n          min-width: auto;\n        }\n      }\n      th:last-child {\n        @media(max-width: 600px) {\n          display: none;\n        }\n  \n      }\n\n      td {\n        background: #fff;\n        color: #333;\n        border-bottom: 1px solid #e0e0e0;\n        transition: all 0.3s ease;\n\n        @media(max-width: 400px) {\n          font-size: 14px !important;\n        }\n      }\n\n      td:last-child {\n        @media(max-width: 600px) {\n          display: none;\n        }\n  \n      }\n\n      tr:hover td {\n        background: #75d0e0;\n        transform: scale(1.02);\n        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);\n      }\n\n      tr.is-highlighted td {\n        font-size: 18px;\n        font-weight: 700;\n      }\n\n      tr:last-child td {\n        border-bottom: none;\n      }\n    }\n  }\n}\n  \n// Анимация появления таблицы\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n",".form {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1000;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  -webkit-overflow-scrolling: touch;\n  background-color: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(2px);\n  padding:\n    max(12px, env(safe-area-inset-top))\n    max(12px, env(safe-area-inset-right))\n    max(12px, env(safe-area-inset-bottom))\n    max(12px, env(safe-area-inset-left));\n\n  @media (min-width: $tablet) {\n    padding: 24px 16px;\n  }\n}\n\n.form-container {\n  position: relative;\n  width: 100%;\n  max-width: 640px;\n  margin: auto;\n  flex-shrink: 0;\n\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: 3;\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    min-width: 36px;\n    min-height: 36px;\n    padding: 0;\n    margin: 0;\n    border: none;\n    border-left: 1px solid rgba($primary, 0.08);\n    border-bottom: 1px solid rgba($primary, 0.08);\n    border-radius: 0 16px 0 10px;\n    background: rgba(255, 255, 255, 0.98);\n    color: $primary;\n    cursor: pointer;\n    flex-shrink: 0;\n    transition: background-color 0.2s ease, color 0.2s ease;\n\n    &:hover {\n      background: $light;\n      color: $action;\n    }\n\n    svg {\n      width: 18px;\n      height: 18px;\n      display: block;\n    }\n  }\n}\n\n.form-content,\n.form-container .form-title-completed {\n  position: relative;\n  width: 100%;\n  border-radius: 16px;\n  background-color: $light;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);\n  border: 1px solid rgba(255, 255, 255, 0.9);\n}\n\n.form-content {\n  padding: 20px 20px 24px;\n}\n\n.form-loading {\n  margin: 0 0 16px;\n  font-size: 15px;\n  color: #6b7280;\n}\n\n.form-container .form-title-completed {\n  padding: 20px 48px 32px 24px;\n  text-align: center;\n  font-size: clamp(18px, 4vw, 22px);\n  font-weight: 600;\n  line-height: 1.4;\n  color: $primary;\n}\n\n.form-group {\n  margin-bottom: 16px;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 6px;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.3;\n  color: $primary;\n}\n\n.required-mark {\n  margin-left: 2px;\n  color: #e53935;\n  font-weight: 600;\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  min-height: 44px;\n  padding: 10px 12px;\n  box-sizing: border-box;\n  border: 1px solid rgba($action, 0.45);\n  border-radius: 10px;\n  font-size: 16px;\n  line-height: 1.2;\n  color: $primary;\n  background-color: $light;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n  &:focus {\n    outline: none;\n    border-color: $action;\n    box-shadow: 0 0 0 3px rgba($action, 0.2);\n  }\n}\n\n.form-group select {\n  appearance: none;\n  padding-right: 36px;\n  background-image: url(\"data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23010101' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  background-size: 16px;\n  cursor: pointer;\n}\n\n.form-consents {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 8px 0 20px;\n}\n\n.form-checkbox {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  margin: 0;\n\n  input[type=\"checkbox\"] {\n    width: 18px;\n    height: 18px;\n    margin-top: 2px;\n    flex-shrink: 0;\n    cursor: pointer;\n  }\n\n  .privacy-link {\n    display: inline-flex;\n    align-items: flex-start;\n    gap: 8px;\n    font-size: 14px;\n    line-height: 1.4;\n    color: $action;\n    text-decoration: underline;\n    word-break: break-word;\n\n    &:hover {\n      opacity: 0.85;\n    }\n  }\n}\n\n.error {\n  display: block;\n  margin-top: 4px;\n  font-size: 13px;\n  line-height: 1.3;\n  color: #e53935;\n}\n\nbutton[type=\"submit\"] {\n  width: 100%;\n  min-height: 48px;\n  padding: 12px 16px;\n  border: none;\n  border-radius: 10px;\n  background-color: $action;\n  color: $light;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.2;\n  cursor: pointer;\n  box-shadow: 0 4px 12px rgba($action, 0.35);\n  transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;\n\n  &:hover:not(:disabled) {\n    background-color: darken($action, 6%);\n    box-shadow: 0 6px 16px rgba($action, 0.4);\n  }\n\n  &:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n}\n\n.popup {\n  position: fixed;\n  inset: 0;\n  z-index: 1100;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  background-color: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(3px);\n}\n\n.popup-content {\n  position: relative;\n  width: min(100%, 400px);\n  padding: 32px 24px 24px;\n  border-radius: 12px;\n  background-color: $light;\n  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.2);\n  text-align: center;\n\n  p {\n    margin-top: 12px;\n    font-size: 16px;\n    line-height: 1.5;\n    color: $primary;\n  }\n}\n\n.close {\n  position: absolute;\n  top: 8px;\n  right: 12px;\n  font-size: 28px;\n  line-height: 1;\n  color: #888;\n  cursor: pointer;\n\n  &:hover {\n    color: $primary;\n  }\n}\n\n@media (max-width: $tablet) {\n  .form-content {\n    padding: 18px 16px 20px;\n    border-radius: 14px;\n  }\n\n  .form-container .form-title-completed {\n    padding: 18px 44px 28px 20px;\n  }\n\n  .form-group {\n    margin-bottom: 12px;\n  }\n}\n\n@media (max-width: $mobile) {\n  .form {\n    padding:\n      max(8px, env(safe-area-inset-top))\n      max(8px, env(safe-area-inset-right))\n      max(8px, env(safe-area-inset-bottom))\n      max(8px, env(safe-area-inset-left));\n  }\n\n  .form-content {\n    padding: 16px 14px 18px;\n    border-radius: 12px;\n  }\n\n  .form-container .btn-close {\n    border-radius: 0 12px 0 8px;\n    width: 34px;\n    height: 34px;\n    min-width: 34px;\n    min-height: 34px;\n\n    svg {\n      width: 16px;\n      height: 16px;\n    }\n  }\n\n  .form-group label {\n    font-size: 13px;\n  }\n\n  .form-checkbox .privacy-link {\n    font-size: 13px;\n  }\n\n  button[type=\"submit\"] {\n    min-height: 44px;\n  }\n}\n","// Admin panel design tokens\n$admin-primary: #2575fc;\n$admin-primary-dark: #1a5ec9;\n$admin-accent: #6a11cb;\n$admin-success: #22a06b;\n$admin-danger: #de350b;\n$admin-warning: #ff991f;\n$admin-bg: #eef1f6;\n$admin-surface: #ffffff;\n$admin-border: #e3e8ef;\n$admin-text: #1f2937;\n$admin-text-muted: #6b7280;\n$admin-radius: 12px;\n$admin-shadow: 0 1px 3px rgba(15, 23, 42, 0.08), 0 4px 16px rgba(15, 23, 42, 0.04);\n\n.App--admin {\n  background: $admin-bg;\n  min-height: 100vh;\n  width: 100%;\n  align-items: stretch;\n\n  > * {\n    width: 100%;\n    min-width: 0;\n  }\n}\n\n.admin-page {\n  width: 100%;\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 24px 20px 48px;\n  box-sizing: border-box;\n  min-width: 0;\n  font-family: $font-family-base;\n  color: $admin-text;\n\n  @media (max-width: $tablet) {\n    padding: 16px 12px 32px;\n  }\n}\n\n// Top bar\n.admin-topbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 16px;\n  margin-bottom: 24px;\n  flex-wrap: wrap;\n\n  &__brand {\n    h1 {\n      margin: 0 0 4px;\n      font-size: 26px;\n      font-weight: 700;\n      letter-spacing: -0.02em;\n      color: $admin-text;\n    }\n\n    p {\n      margin: 0;\n      font-size: 14px;\n      color: $admin-text-muted;\n    }\n  }\n\n  &__actions {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n  }\n}\n\n.admin-link-btn {\n  display: inline-flex;\n  align-items: center;\n  padding: 9px 16px;\n  border-radius: 8px;\n  border: 1px solid $admin-border;\n  background: $admin-surface;\n  color: $admin-text;\n  font-size: 14px;\n  font-weight: 500;\n  text-decoration: none;\n  transition: all 0.15s ease;\n\n  &:hover {\n    border-color: $admin-primary;\n    color: $admin-primary;\n    background: #f5f9ff;\n  }\n}\n\n.admin-logout-btn {\n  padding: 9px 16px;\n  border-radius: 8px;\n  border: 1px solid $admin-border;\n  background: $admin-surface;\n  color: $admin-text-muted;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s ease;\n\n  &:hover {\n    border-color: $admin-danger;\n    color: $admin-danger;\n    background: #fff5f5;\n  }\n}\n\n// Stats row\n.admin-stats {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 20px;\n  width: 100%;\n\n  @media (max-width: $tablet) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.admin-stat-card {\n  background: $admin-surface;\n  border: 1px solid $admin-border;\n  border-radius: $admin-radius;\n  padding: 16px 18px;\n  box-shadow: $admin-shadow;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  min-height: 132px;\n\n  &__label {\n    font-size: 13px;\n    color: $admin-text-muted;\n    font-weight: 500;\n  }\n\n  &__value {\n    font-size: 28px;\n    font-weight: 700;\n    line-height: 1;\n    color: $admin-text;\n  }\n\n  &__summary {\n    margin: 0;\n    font-size: 12px;\n    line-height: 1.4;\n    color: $admin-text-muted;\n  }\n\n  &__hint {\n    margin: 0;\n    font-size: 12px;\n    line-height: 1.4;\n    color: $admin-text-muted;\n  }\n\n  &__breakdown {\n    margin: 4px 0 0;\n    padding: 0;\n    list-style: none;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n\n    li {\n      display: flex;\n      align-items: flex-start;\n      justify-content: space-between;\n      gap: 10px;\n      font-size: 12px;\n      line-height: 1.35;\n    }\n  }\n\n  &__breakdown-label {\n    color: $admin-text;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  &__breakdown-value {\n    flex-shrink: 0;\n    font-weight: 700;\n    color: $admin-primary-dark;\n  }\n\n  &--participants {\n    .admin-stat-card__value {\n      color: $admin-primary-dark;\n    }\n  }\n\n  &--programs {\n    .admin-stat-card__value {\n      color: $admin-accent;\n    }\n  }\n}\n\n.admin-status-badge {\n  display: inline-flex;\n  align-items: center;\n  width: fit-content;\n  padding: 4px 10px;\n  border-radius: 999px;\n  font-size: 13px;\n  font-weight: 600;\n\n  &.is-open {\n    background: #e3fcef;\n    color: #006644;\n  }\n\n  &.is-closed {\n    background: #ffebe6;\n    color: #bf2600;\n  }\n}\n\n// Section cards\n.admin-section-card {\n  background: $admin-surface;\n  border: 1px solid $admin-border;\n  border-radius: $admin-radius;\n  box-shadow: $admin-shadow;\n  margin-bottom: 16px;\n  overflow: hidden;\n  width: 100%;\n  min-width: 0;\n\n  &--highlight {\n    border-color: #c8dafc;\n    background: linear-gradient(180deg, #f8fbff 0%, $admin-surface 100%);\n  }\n\n  &__header {\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    padding: 18px 20px;\n    border: none;\n    background: transparent;\n    text-align: left;\n    transition: background 0.15s ease;\n\n    &:hover {\n      background: #f8fafc;\n    }\n\n    &.is-open {\n      border-bottom: 1px solid $admin-border;\n    }\n\n    @media (max-width: $tablet) {\n      flex-wrap: wrap;\n\n      .admin-section-card__toggle {\n        flex: 1 1 calc(100% - 48px);\n      }\n\n      .admin-section-card__actions {\n        order: 3;\n        width: 100%;\n      }\n    }\n  }\n\n  &__toggle {\n    flex: 1;\n    min-width: 0;\n    display: flex;\n    align-items: center;\n    padding: 0;\n    border: none;\n    background: transparent;\n    cursor: pointer;\n    text-align: left;\n    color: inherit;\n    font: inherit;\n  }\n\n  &__actions {\n    flex-shrink: 0;\n  }\n\n  &__programs-toggle {\n    padding: 7px 12px;\n    font-size: 13px;\n  }\n\n  &__chevron-btn {\n    flex-shrink: 0;\n    width: 36px;\n    height: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    border: none;\n    border-radius: 8px;\n    background: transparent;\n    cursor: pointer;\n\n    &:hover {\n      background: #eef2f7;\n    }\n  }\n\n  &__collapse {\n    overflow: hidden;\n    will-change: height, opacity;\n  }\n\n  &__title-wrap {\n    h3 {\n      margin: 0 0 2px;\n      font-size: 17px;\n      font-weight: 600;\n      color: $admin-text;\n    }\n\n    p {\n      margin: 0;\n      font-size: 13px;\n      color: $admin-text-muted;\n    }\n  }\n\n  &__chevron {\n    flex-shrink: 0;\n    width: 10px;\n    height: 10px;\n    border-right: 2px solid $admin-text-muted;\n    border-bottom: 2px solid $admin-text-muted;\n    transform: rotate(45deg);\n    transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1), margin-top 0.35s cubic-bezier(0.4, 0, 0.2, 1);\n\n    &.is-open {\n      transform: rotate(-135deg);\n      margin-top: 4px;\n    }\n  }\n\n  &__body {\n    padding: 20px;\n    overflow: hidden;\n    min-width: 0;\n    max-width: 100%;\n\n    &--flat {\n      padding: 0;\n    }\n  }\n}\n\n// Registration controls\n.registration-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 20px;\n  padding: 20px 24px;\n  flex-wrap: wrap;\n  width: 100%;\n  box-sizing: border-box;\n\n  &__info {\n    flex: 1;\n    min-width: 200px;\n\n    h2 {\n      margin: 0 0 6px;\n      font-size: 16px;\n      font-weight: 600;\n    }\n\n    p {\n      margin: 0;\n      font-size: 14px;\n      color: $admin-text-muted;\n      line-height: 1.45;\n    }\n  }\n\n  button {\n    flex-shrink: 0;\n  }\n}\n\n// Action buttons\n.admin-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 10px 16px;\n  border-radius: 8px;\n  border: none;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.15s ease;\n  white-space: nowrap;\n\n  &:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n  }\n\n  &--primary {\n    background: linear-gradient(135deg, $admin-primary, $admin-accent);\n    color: #fff;\n    box-shadow: 0 2px 8px rgba(37, 117, 252, 0.3);\n\n    &:hover:not(:disabled) {\n      filter: brightness(1.05);\n      transform: translateY(-1px);\n    }\n  }\n\n  &--secondary {\n    background: #f3f4f6;\n    color: $admin-text;\n\n    &:hover:not(:disabled) {\n      background: #e5e7eb;\n    }\n  }\n\n  &--success {\n    background: $admin-success;\n    color: #fff;\n\n    &:hover:not(:disabled) {\n      filter: brightness(1.05);\n    }\n  }\n\n  &--danger {\n    background: $admin-danger;\n    color: #fff;\n\n    &:hover:not(:disabled) {\n      filter: brightness(1.05);\n    }\n  }\n\n  &--ghost-danger {\n    background: transparent;\n    border: 1px solid #ffb3a8;\n    color: $admin-danger;\n\n    &:hover:not(:disabled) {\n      background: #fff5f5;\n    }\n  }\n}\n\n.complete-registration-btn.clicked,\n.reopen-registration-btn.clicked {\n  opacity: 0.85;\n}\n\n.admin-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n\n  &--compact {\n    margin-top: 4px;\n  }\n\n  &__count {\n    margin-left: auto;\n    font-size: 13px;\n    color: $admin-text-muted;\n    font-weight: 600;\n  }\n}\n\n// Forms\n.admin-form {\n  background: #f8fafc;\n  border: 1px solid $admin-border;\n  border-radius: 10px;\n  padding: 20px;\n  min-width: 0;\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.admin-form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 14px;\n  margin-bottom: 20px;\n\n  @media (max-width: $tablet) {\n    grid-template-columns: 1fr;\n  }\n}\n\n.admin-field--wide {\n  grid-column: 1 / -1;\n}\n\n.program-title-heading {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n\n  > label[for=\"program-title\"] {\n    margin: 0;\n  }\n\n  &__controls {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n    flex-wrap: wrap;\n  }\n}\n\n.admin-inline-check {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: $admin-text;\n  cursor: pointer;\n  user-select: none;\n\n  input {\n    width: 16px;\n    height: 16px;\n    margin: 0;\n    accent-color: $admin-primary;\n    cursor: pointer;\n  }\n}\n\n.program-title-size {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n  font-size: 13px;\n  font-weight: 600;\n  color: $admin-text-muted;\n\n  select {\n    width: auto;\n    min-width: 150px;\n    padding: 6px 10px;\n    font-size: 13px;\n  }\n}\n\n.admin-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n\n  label {\n    font-size: 13px;\n    font-weight: 600;\n    color: $admin-text-muted;\n  }\n\n  .admin-field-hint {\n    font-size: 12px;\n    line-height: 1.4;\n    color: $admin-text-muted;\n\n    code {\n      padding: 1px 5px;\n      border-radius: 4px;\n      background: rgba(31, 41, 55, 0.06);\n      font-size: 12px;\n    }\n  }\n\n  input,\n  textarea,\n  select {\n    width: 100%;\n    padding: 10px 12px;\n    border: 1px solid $admin-border;\n    border-radius: 8px;\n    font-size: 15px;\n    font-family: inherit;\n    color: $admin-text;\n    background: $admin-surface;\n    box-sizing: border-box;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n\n    &::placeholder {\n      color: #9ca3af;\n    }\n\n    &:focus {\n      outline: none;\n      border-color: $admin-primary;\n      box-shadow: 0 0 0 3px rgba(37, 117, 252, 0.12);\n    }\n\n    &:disabled {\n      background: #f3f4f6;\n      color: $admin-text-muted;\n    }\n  }\n\n  textarea {\n    resize: vertical;\n    min-height: 72px;\n  }\n}\n\n.admin-form-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  margin-top: 20px;\n  padding-top: 16px;\n  border-top: 1px solid $admin-border;\n  flex-wrap: wrap;\n\n  @media (max-width: $tablet) {\n    flex-direction: column;\n\n    .admin-action-btn {\n      width: 100%;\n    }\n  }\n}\n\n// Table rows in editor\n.table-row {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 12px;\n  padding: 14px;\n  background: $admin-surface;\n  border: 1px solid $admin-border;\n  border-radius: 10px;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  min-width: 0;\n  max-width: 100%;\n\n  &:hover {\n    box-shadow: 0 2px 8px rgba(15, 23, 42, 0.06);\n  }\n\n  &.is-selected {\n    border-color: $admin-primary;\n    background: #f5f9ff;\n  }\n\n  @media (max-width: $tablet) {\n    flex-direction: column;\n  }\n\n  &__number {\n    flex-shrink: 0;\n    width: 28px;\n    height: 28px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f3f4f6;\n    border-radius: 6px;\n    font-size: 13px;\n    font-weight: 700;\n    color: $admin-text-muted;\n    margin-top: 24px;\n\n    @media (max-width: $tablet) {\n      margin-top: 0;\n    }\n  }\n\n  &__fields {\n    flex: 1;\n    min-width: 0;\n    display: grid;\n    grid-template-columns: minmax(100px, 140px) minmax(0, 1fr) minmax(0, 1fr);\n    gap: 12px;\n\n    @media (max-width: $laptop) {\n      grid-template-columns: 1fr;\n    }\n  }\n}\n\n.row-actions {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex-shrink: 0;\n  min-width: 110px;\n\n  @media (max-width: $tablet) {\n    flex-direction: row;\n    flex-wrap: wrap;\n    min-width: 0;\n  }\n}\n\n.row-action-btn {\n  padding: 7px 10px;\n  border: none;\n  border-radius: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: filter 0.15s ease;\n\n  &--warn {\n    background: #fff7e6;\n    color: #b76e00;\n  }\n\n  &--danger {\n    background: #ffebe6;\n    color: $admin-danger;\n  }\n\n  &--select {\n    background: #e6f4ff;\n    color: #0958d9;\n\n    &.is-active {\n      background: $admin-primary;\n      color: #fff;\n    }\n  }\n\n  &:hover {\n    filter: brightness(0.96);\n  }\n}\n\n// Registrations table\n.registrations-list-wrap {\n  margin-top: 4px;\n}\n\n.registration-forum-tabs-scroll {\n  overflow-x: auto;\n  margin: 0 0 16px;\n  padding-bottom: 4px;\n  max-width: 100%;\n  -webkit-overflow-scrolling: touch;\n}\n\n.registration-forum-tabs {\n  display: flex;\n  gap: 8px;\n  width: max-content;\n  max-width: none;\n}\n\n.registration-forum-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  border: 1px solid $admin-border;\n  border-radius: 999px;\n  background: #fff;\n  color: $admin-text;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n  white-space: nowrap;\n\n  &__label {\n    max-width: 260px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n  }\n\n  &__count {\n    min-width: 22px;\n    padding: 2px 7px;\n    border-radius: 999px;\n    background: #eef2f7;\n    color: $admin-text-muted;\n    font-size: 12px;\n    font-weight: 700;\n    text-align: center;\n  }\n\n  &.is-active {\n    border-color: $admin-primary;\n    background: #e8f1ff;\n    color: $admin-primary-dark;\n\n    .registration-forum-tab__count {\n      background: $admin-primary;\n      color: #fff;\n    }\n  }\n}\n\n.registration-forum-panel {\n  min-width: 0;\n}\n\n.registrations-list {\n  overflow-x: auto;\n  border: 1px solid $admin-border;\n  border-radius: 10px;\n}\n\n.registrations-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n\n  th,\n  td {\n    padding: 11px 14px;\n    text-align: left;\n    border-bottom: 1px solid $admin-border;\n    white-space: nowrap;\n  }\n\n  th {\n    background: #f8fafc;\n    color: $admin-text-muted;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.03em;\n    position: sticky;\n    top: 0;\n  }\n\n  tbody tr:hover td {\n    background: #f8fafc;\n  }\n\n  tbody tr:last-child td {\n    border-bottom: none;\n  }\n}\n\n.admin-empty-state {\n  text-align: center;\n  padding: 32px 20px;\n  color: $admin-text-muted;\n\n  p {\n    margin: 0 0 12px;\n    font-size: 15px;\n  }\n\n  &--compact {\n    padding: 24px 16px;\n    background: #f8fafc;\n    border: 1px dashed $admin-border;\n    border-radius: 10px;\n    margin-bottom: 12px;\n  }\n}\n\n// Program editor tabs\n.program-documents-editor {\n  min-width: 0;\n  max-width: 100%;\n\n  .program-tabs-scroll {\n    overflow-x: auto;\n    margin-bottom: 16px;\n    padding-bottom: 4px;\n    max-width: 100%;\n    -webkit-overflow-scrolling: touch;\n  }\n\n  .program-tabs {\n    display: flex;\n    gap: 8px;\n    width: max-content;\n    max-width: none;\n  }\n\n  .program-tab {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 12px;\n    border: 1px solid $admin-border;\n    border-radius: 8px;\n    background: $admin-surface;\n    color: $admin-text;\n    font-size: 13px;\n    font-weight: 500;\n    cursor: grab;\n    transition: all 0.15s ease;\n    max-width: 240px;\n\n    &__index {\n      flex-shrink: 0;\n      width: 20px;\n      height: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: #f3f4f6;\n      border-radius: 4px;\n      font-size: 11px;\n      font-weight: 700;\n      color: $admin-text-muted;\n    }\n\n    &__label {\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n\n    &__drag {\n      color: #c4c9d2;\n      font-size: 11px;\n      letter-spacing: -2px;\n    }\n\n    &.is-active {\n      border-color: $admin-primary;\n      background: #f0f7ff;\n      color: $admin-primary;\n\n      .program-tab__index {\n        background: $admin-primary;\n        color: #fff;\n      }\n    }\n\n    &.is-drag-over {\n      border-color: $admin-accent;\n      background: #f8f4ff;\n    }\n\n    &--add {\n      cursor: pointer;\n      border-style: dashed;\n      color: $admin-text-muted;\n      max-width: none;\n\n      &:hover {\n        border-color: $admin-primary;\n        color: $admin-primary;\n      }\n    }\n\n    &:active {\n      cursor: grabbing;\n    }\n  }\n\n  .program-editor-toolbar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 12px;\n    margin-bottom: 16px;\n    flex-wrap: wrap;\n  }\n\n  .program-editor-hint {\n    margin: 0;\n    font-size: 13px;\n    color: $admin-text-muted;\n  }\n\n  .program-table-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: 12px;\n\n    h4 {\n      margin: 0;\n      font-size: 15px;\n      font-weight: 600;\n    }\n  }\n\n  .program-table-count {\n    font-size: 12px;\n    color: $admin-text-muted;\n    background: #f3f4f6;\n    padding: 3px 8px;\n    border-radius: 999px;\n  }\n}\n\n.program-block {\n  & + & {\n    margin-top: 8px;\n  }\n}\n\n// Modals & toasts\n.admin-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.45);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.admin-modal {\n  background: $admin-surface;\n  border-radius: 16px;\n  padding: 28px 32px;\n  max-width: 360px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 20px 60px rgba(15, 23, 42, 0.2);\n\n  h3 {\n    margin: 12px 0 8px;\n    font-size: 18px;\n    font-weight: 700;\n  }\n\n  p {\n    margin: 0;\n    font-size: 14px;\n    color: $admin-text-muted;\n    line-height: 1.5;\n  }\n\n  &--confirm {\n    max-width: 420px;\n    text-align: left;\n\n    h3,\n    p {\n      text-align: left;\n    }\n\n    .admin-modal__icon {\n      margin: 0 0 4px;\n    }\n  }\n\n  &__actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    margin-top: 20px;\n    justify-content: flex-end;\n  }\n\n  &__icon {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 0 auto;\n    font-size: 22px;\n    font-weight: 700;\n\n    &--success {\n      background: #e3fcef;\n      color: $admin-success;\n    }\n\n    &--warning {\n      background: #fff7e6;\n      color: $admin-warning;\n    }\n  }\n}\n\n.admin-toast {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  padding: 12px 18px;\n  border-radius: 10px;\n  color: #fff;\n  font-size: 14px;\n  font-weight: 500;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.18);\n  z-index: 9999;\n  max-width: calc(100vw - 40px);\n\n  &--success {\n    background: $admin-success;\n  }\n}\n\n// Loading\n.admin-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  padding: 40px 20px;\n\n  .loading-spinner {\n    width: 44px;\n    height: 44px;\n    border: 3px solid #e5e7eb;\n    border-top-color: $admin-primary;\n    border-radius: 50%;\n    margin-bottom: 16px;\n    animation: admin-spin 0.8s linear infinite;\n  }\n\n  p {\n    margin: 0;\n    font-size: 15px;\n    color: $admin-text-muted;\n  }\n}\n\n@keyframes admin-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n// Legacy class aliases (route guard)\n.admin-panel {\n  @extend .admin-page;\n}\n\n.popup-overlay {\n  @extend .admin-modal-overlay;\n}\n\n.popup-content {\n  @extend .admin-modal;\n}\n\n@media (max-width: $tablet) {\n  .admin-topbar__brand h1 {\n    font-size: 22px;\n  }\n\n  .registration-controls {\n    flex-direction: column;\n    align-items: stretch;\n\n    button {\n      width: 100%;\n    }\n  }\n\n  .admin-toolbar {\n    flex-direction: column;\n\n    .admin-action-btn {\n      width: 100%;\n    }\n  }\n}\n\n.form-field-row {\n  &.is-drag-over {\n    border-color: $admin-primary;\n    box-shadow: 0 0 0 3px rgba(37, 117, 252, 0.12);\n  }\n\n  &.is-locked {\n    background: #f8fafc;\n  }\n\n  &__handle {\n    cursor: grab;\n    user-select: none;\n    letter-spacing: -2px;\n\n    &:active {\n      cursor: grabbing;\n    }\n  }\n\n  &__fields {\n    grid-template-columns: minmax(0, 1.4fr) minmax(120px, 160px) minmax(0, 1fr);\n    align-items: start;\n\n    @media (max-width: $laptop) {\n      grid-template-columns: 1fr;\n    }\n  }\n}\n\n.form-field-required {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 22px;\n  font-size: 13px;\n  font-weight: 600;\n  color: $admin-text;\n  cursor: pointer;\n\n  input {\n    width: 16px;\n    height: 16px;\n    accent-color: $admin-primary;\n  }\n\n  @media (max-width: $laptop) {\n    margin-top: 0;\n  }\n}\n\n.form-field-locked-note {\n  grid-column: 1 / -1;\n  margin: 0;\n  font-size: 12px;\n  color: $admin-text-muted;\n}\n\n.form-field-options {\n  grid-column: 1 / -1;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 12px;\n  background: #f8fafc;\n  border: 1px dashed $admin-border;\n  border-radius: 8px;\n\n  &__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 8px;\n    font-size: 13px;\n    font-weight: 600;\n    color: $admin-text-muted;\n  }\n}\n\n.form-field-option {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n\n  input {\n    flex: 1;\n    min-width: 0;\n    padding: 8px 10px;\n    border: 1px solid $admin-border;\n    border-radius: 8px;\n    font-size: 14px;\n    font-family: inherit;\n    box-sizing: border-box;\n\n    &:focus {\n      outline: none;\n      border-color: $admin-primary;\n    }\n  }\n}\n\n.registration-form-editor {\n  .admin-form-footer {\n    justify-content: flex-start;\n  }\n\n  .row-action-btn:disabled {\n    opacity: 0.45;\n    cursor: not-allowed;\n  }\n}\n\n.homepage-intro-editor {\n  .program-editor-hint {\n    margin-bottom: 16px;\n  }\n}\n\n.homepage-intro-preview {\n  margin-top: 4px;\n  padding: 16px;\n  border: 1px dashed $admin-border;\n  border-radius: 12px;\n  background: linear-gradient(90deg, rgba(205, 253, 254, 0.7) 0%, rgba(233, 242, 244, 1) 50%);\n\n  &__label {\n    display: block;\n    margin-bottom: 8px;\n    font-size: 12px;\n    font-weight: 600;\n    color: $admin-text-muted;\n    text-transform: uppercase;\n    letter-spacing: 0.04em;\n  }\n\n  &__empty {\n    margin: 12px 0 4px;\n    text-align: center;\n    color: $admin-text-muted;\n    font-size: 14px;\n  }\n\n  .homepage-intro {\n    padding: 0;\n  }\n\n  .promo-title {\n    padding: 16px 8px 10px;\n  }\n\n  .promo-highlight {\n    margin-bottom: 8px;\n  }\n}\n",".admin-login {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n  padding: 24px 16px;\n  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%);\n\n  .admin-login-form {\n    width: 100%;\n    min-width: 280px;\n    max-width: 400px;\n    background: #fff;\n    padding: 32px 28px;\n    border-radius: 12px;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n\n    h3 {\n      margin: 0 0 24px;\n      color: #333;\n      font-size: 20px;\n      font-weight: 600;\n      line-height: 1.3;\n    }\n\n    input {\n      width: 100%;\n      padding: 12px 14px;\n      margin-bottom: 12px;\n      border: 1px solid #ddd;\n      border-radius: 6px;\n      font-size: 16px;\n      box-sizing: border-box;\n      transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n      &:focus {\n        border-color: #2575fc;\n        outline: none;\n        box-shadow: 0 0 0 2px rgba(37, 117, 252, 0.2);\n      }\n\n      &:disabled {\n        opacity: 0.7;\n        cursor: not-allowed;\n      }\n    }\n\n    .error {\n      color: #dc3545;\n      margin: 0 0 12px;\n      font-size: 14px;\n    }\n\n    button {\n      width: 100%;\n      background: linear-gradient(135deg, #2575fc, #6a11cb);\n      color: white;\n      border: none;\n      padding: 12px 20px;\n      border-radius: 6px;\n      cursor: pointer;\n      font-size: 16px;\n      font-weight: 500;\n      transition: all 0.2s ease;\n\n      &:hover:not(:disabled) {\n        background: linear-gradient(135deg, #1a5ec9, #5910a8);\n        transform: translateY(-1px);\n      }\n\n      &:disabled {\n        opacity: 0.7;\n        cursor: not-allowed;\n      }\n    }\n\n    .admin-login-home-link {\n      display: inline-block;\n      margin-top: 16px;\n      color: #666;\n      font-size: 14px;\n      text-decoration: none;\n      transition: color 0.2s ease;\n\n      &:hover {\n        color: #2575fc;\n        text-decoration: underline;\n      }\n    }\n  }\n}\n",".footer {\n  margin-top: auto;\n  padding: 48px 0 20px;\n  position: relative;\n  z-index: 1;\n  background: linear-gradient(135deg, #eefbfe 0%, #e7f4f6 100%);\n  border-top: 1px solid rgba(44, 202, 241, 0.28);\n\n  @media (max-width: $tablet) {\n    padding-top: 36px;\n  }\n\n  &-wrapper {\n    display: grid;\n    grid-template-columns: minmax(210px, 1.15fr) repeat(3, minmax(180px, 1fr));\n    gap: 40px;\n    align-items: start;\n\n    @media (max-width: $laptop) {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n      gap: 36px 48px;\n    }\n\n    @media (max-width: $tablet) {\n      grid-template-columns: 1fr;\n      gap: 30px;\n    }\n  }\n\n  &-brand {\n    max-width: 270px;\n\n    @media (max-width: $tablet) {\n      max-width: none;\n    }\n  }\n\n  &-logo {\n    display: flex;\n    justify-content: flex-start;\n    margin-bottom: 18px;\n\n    img {\n      width: 86px;\n      height: auto;\n    }\n  }\n\n  &-description {\n    color: #71848a;\n    font-size: 14px;\n    line-height: 1.25;\n  }\n\n  &-section {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    color: $primary;\n\n    h3 {\n      margin: 0 0 8px;\n      font-size: 20px;\n      line-height: 1.2;\n      font-weight: 700;\n    }\n\n    p,\n    address,\n    a {\n      margin: 0;\n      color: inherit;\n      font-size: 15px;\n      line-height: 1.35;\n      font-style: normal;\n    }\n\n    a {\n      transition: color 0.2s ease;\n\n      &:hover {\n        color: $action;\n      }\n    }\n\n    .socials {\n      display: flex;\n      justify-content: flex-start;\n      margin-top: 10px;\n    }\n  }\n\n  &-schedule {\n    gap: 14px;\n\n    h3 {\n      margin-bottom: 2px;\n    }\n  }\n\n  &-bottom {\n    margin-top: 38px;\n    padding-top: 18px;\n    border-top: 1px solid rgba(1, 1, 1, 0.1);\n    color: #71848a;\n    font-size: 13px;\n    text-align: center;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
